define((require) => {
    "use strict";

    const _               = require("underscore");
    const ButtonIconModel = require("shared/ui/experience/widgets/button/ButtonIconModel");

    // from https://material.io/icons/data/grid.json
    return {
        groups: [{
            "length": 216,
            "data": {
                "id": "action",
                "name": "Action"
            }
        }, {
            "length": 4,
            "data": {
                "id": "alert",
                "name": "Alert"
            }
        }, {
            "length": 80,
            "data": {
                "id": "av",
                "name": "AV"
            }
        }, {
            "length": 50,
            "data": {
                "id": "communication",
                "name": "Communication"
            }
        }, {
            "length": 41,
            "data": {
                "id": "content",
                "name": "Content"
            }
        }, {
            "length": 52,
            "data": {
                "id": "device",
                "name": "Device"
            }
        }, {
            "length": 68,
            "data": {
                "id": "editor",
                "name": "Editor"
            }
        }, {
            "length": 14,
            "data": {
                "id": "file",
                "name": "File"
            }
        }, {
            "length": 48,
            "data": {
                "id": "hardware",
                "name": "Hardware"
            }
        }, {
            "length": 155,
            "data": {
                "id": "image",
                "name": "Image"
            }
        }, {
            "length": 68,
            "data": {
                "id": "maps",
                "name": "Maps"
            }
        }, {
            "length": 25,
            "data": {
                "id": "navigation",
                "name": "Navigation"
            }
        }, {
            "length": 53,
            "data": {
                "id": "notification",
                "name": "Notification"
            }
        }, {
            "length": 19,
            "data": {
                "id": "places",
                "name": "Places"
            }
        }, {
            "length": 30,
            "data": {
                "id": "social",
                "name": "Social"
            }
        }, {
            "length": 8,
            "data": {
                "id": "toggle",
                "name": "Toggle"
            }
        }],
        icons: [{
            "iconId": "3d_rotation",
            "name": "3d rotation",
            "groupId": "action",
            "ligature": "3d_rotation",
            "codepoint": "E84D"
        }, {
            "iconId": "accessibility",
            "name": "accessibility",
            "groupId": "action",
            "ligature": "accessibility",
            "codepoint": "E84E"
        }, {
            "iconId": "accessible",
            "name": "accessible",
            "groupId": "action",
            "ligature": "accessible",
            "codepoint": "E914"
        }, {
            "iconId": "account_balance",
            "name": "account balance",
            "groupId": "action",
            "ligature": "account_balance",
            "codepoint": "E84F"
        }, {
            "iconId": "account_balance_wallet",
            "name": "account balance wallet",
            "groupId": "action",
            "ligature": "account_balance_wallet",
            "codepoint": "E850"
        }, {
            "iconId": "account_box",
            "name": "account box",
            "groupId": "action",
            "ligature": "account_box",
            "codepoint": "E851"
        }, {
            "iconId": "account_circle",
            "name": "account circle",
            "groupId": "action",
            "ligature": "account_circle",
            "codepoint": "E853"
        }, {
            "iconId": "add_shopping_cart",
            "name": "add shopping cart",
            "groupId": "action",
            "ligature": "add_shopping_cart",
            "codepoint": "E854"
        }, {
            "iconId": "alarm",
            "name": "alarm",
            "groupId": "action",
            "ligature": "alarm",
            "codepoint": "E855"
        }, {
            "iconId": "alarm_add",
            "name": "alarm add",
            "groupId": "action",
            "ligature": "alarm_add",
            "codepoint": "E856"
        }, {
            "iconId": "alarm_off",
            "name": "alarm off",
            "groupId": "action",
            "ligature": "alarm_off",
            "codepoint": "E857"
        }, {
            "iconId": "alarm_on",
            "name": "alarm on",
            "groupId": "action",
            "ligature": "alarm_on",
            "codepoint": "E858"
        }, {
            "iconId": "all_out",
            "name": "all out",
            "groupId": "action",
            "ligature": "all_out",
            "codepoint": "E90B"
        }, {
            "iconId": "android",
            "name": "android",
            "groupId": "action",
            "ligature": "android",
            "codepoint": "E859"
        }, {
            "iconId": "announcement",
            "name": "announcement",
            "groupId": "action",
            "ligature": "announcement",
            "codepoint": "E85A"
        }, {
            "iconId": "aspect_ratio",
            "name": "aspect ratio",
            "groupId": "action",
            "ligature": "aspect_ratio",
            "codepoint": "E85B"
        }, {
            "iconId": "assessment",
            "name": "assessment",
            "groupId": "action",
            "ligature": "assessment",
            "codepoint": "E85C"
        }, {
            "iconId": "assignment",
            "name": "assignment",
            "groupId": "action",
            "ligature": "assignment",
            "codepoint": "E85D"
        }, {
            "iconId": "assignment_ind",
            "name": "assignment ind",
            "groupId": "action",
            "ligature": "assignment_ind",
            "codepoint": "E85E"
        }, {
            "iconId": "assignment_late",
            "name": "assignment late",
            "groupId": "action",
            "ligature": "assignment_late",
            "codepoint": "E85F"
        }, {
            "iconId": "assignment_return",
            "name": "assignment return",
            "groupId": "action",
            "ligature": "assignment_return",
            "codepoint": "E860"
        }, {
            "iconId": "assignment_returned",
            "name": "assignment returned",
            "groupId": "action",
            "ligature": "assignment_returned",
            "codepoint": "E861"
        }, {
            "iconId": "assignment_turned_in",
            "name": "assignment turned in",
            "groupId": "action",
            "ligature": "assignment_turned_in",
            "codepoint": "E862"
        }, {
            "iconId": "autorenew",
            "name": "autorenew",
            "groupId": "action",
            "ligature": "autorenew",
            "codepoint": "E863"
        }, {
            "iconId": "backup",
            "name": "backup",
            "groupId": "action",
            "ligature": "backup",
            "codepoint": "E864"
        }, {
            "iconId": "book",
            "name": "book",
            "groupId": "action",
            "ligature": "book",
            "codepoint": "E865"
        }, {
            "iconId": "bookmark",
            "name": "bookmark",
            "groupId": "action",
            "ligature": "bookmark",
            "codepoint": "E866"
        }, {
            "iconId": "bookmark_border",
            "name": "bookmark border",
            "groupId": "action",
            "ligature": "bookmark_border",
            "codepoint": "E867"
        }, {
            "iconId": "bug_report",
            "name": "bug report",
            "groupId": "action",
            "ligature": "bug_report",
            "codepoint": "E868"
        }, {
            "iconId": "build",
            "name": "build",
            "groupId": "action",
            "ligature": "build",
            "codepoint": "E869"
        }, {
            "iconId": "cached",
            "name": "cached",
            "groupId": "action",
            "ligature": "cached",
            "codepoint": "E86A"
        }, {
            "iconId": "camera_enhance",
            "name": "camera enhance",
            "groupId": "action",
            "ligature": "camera_enhance",
            "codepoint": "E8FC"
        }, {
            "iconId": "card_giftcard",
            "name": "card giftcard",
            "groupId": "action",
            "ligature": "card_giftcard",
            "codepoint": "E8F6"
        }, {
            "iconId": "card_membership",
            "name": "card membership",
            "groupId": "action",
            "ligature": "card_membership",
            "codepoint": "E8F7"
        }, {
            "iconId": "card_travel",
            "name": "card travel",
            "groupId": "action",
            "ligature": "card_travel",
            "codepoint": "E8F8"
        }, {
            "iconId": "change_history",
            "name": "change history",
            "groupId": "action",
            "ligature": "change_history",
            "codepoint": "E86B"
        }, {
            "iconId": "check_circle",
            "name": "check circle",
            "groupId": "action",
            "ligature": "check_circle",
            "codepoint": "E86C"
        }, {
            "iconId": "chrome_reader_mode",
            "name": "chrome reader mode",
            "groupId": "action",
            "ligature": "chrome_reader_mode",
            "codepoint": "E86D"
        }, {
            "iconId": "class",
            "name": "class",
            "groupId": "action",
            "ligature": "class",
            "codepoint": "E86E"
        }, {
            "iconId": "code",
            "name": "code",
            "groupId": "action",
            "ligature": "code",
            "codepoint": "E86F"
        }, {
            "iconId": "compare_arrows",
            "name": "compare arrows",
            "groupId": "action",
            "ligature": "compare_arrows",
            "codepoint": "E915"
        }, {
            "iconId": "copyright",
            "name": "copyright",
            "groupId": "action",
            "ligature": "copyright",
            "codepoint": "E90C"
        }, {
            "iconId": "credit_card",
            "name": "credit card",
            "groupId": "action",
            "ligature": "credit_card",
            "codepoint": "E870"
        }, {
            "iconId": "dashboard",
            "name": "dashboard",
            "groupId": "action",
            "ligature": "dashboard",
            "codepoint": "E871"
        }, {
            "iconId": "date_range",
            "name": "date range",
            "groupId": "action",
            "ligature": "date_range",
            "codepoint": "E916"
        }, {
            "iconId": "delete",
            "name": "delete",
            "groupId": "action",
            "ligature": "delete",
            "codepoint": "E872"
        }, {
            "iconId": "delete_forever",
            "name": "delete forever",
            "groupId": "action",
            "ligature": "delete_forever",
            "codepoint": "E92B"
        }, {
            "iconId": "description",
            "name": "description",
            "groupId": "action",
            "ligature": "description",
            "codepoint": "E873"
        }, {
            "iconId": "dns",
            "name": "dns",
            "groupId": "action",
            "ligature": "dns",
            "codepoint": "E875"
        }, {
            "iconId": "done",
            "name": "done",
            "groupId": "action",
            "ligature": "done",
            "codepoint": "E876"
        }, {
            "iconId": "done_all",
            "name": "done all",
            "groupId": "action",
            "ligature": "done_all",
            "codepoint": "E877"
        }, {
            "iconId": "donut_large",
            "name": "donut large",
            "groupId": "action",
            "ligature": "donut_large",
            "codepoint": "E917"
        }, {
            "iconId": "donut_small",
            "name": "donut small",
            "groupId": "action",
            "ligature": "donut_small",
            "codepoint": "E918"
        }, {
            "iconId": "eject",
            "name": "eject",
            "groupId": "action",
            "ligature": "eject",
            "codepoint": "E8FB"
        }, {
            "iconId": "euro_symbol",
            "name": "euro symbol",
            "groupId": "action",
            "ligature": "euro_symbol",
            "codepoint": "E926"
        }, {
            "iconId": "event",
            "name": "event",
            "groupId": "action",
            "ligature": "event",
            "codepoint": "E878"
        }, {
            "iconId": "event_seat",
            "name": "event seat",
            "groupId": "action",
            "ligature": "event_seat",
            "codepoint": "E903"
        }, {
            "iconId": "exit_to_app",
            "name": "exit to app",
            "groupId": "action",
            "ligature": "exit_to_app",
            "codepoint": "E879"
        }, {
            "iconId": "explore",
            "name": "explore",
            "groupId": "action",
            "ligature": "explore",
            "codepoint": "E87A"
        }, {
            "iconId": "extension",
            "name": "extension",
            "groupId": "action",
            "ligature": "extension",
            "codepoint": "E87B"
        }, {
            "iconId": "face",
            "name": "face",
            "groupId": "action",
            "ligature": "face",
            "codepoint": "E87C"
        }, {
            "iconId": "favorite",
            "name": "favorite",
            "groupId": "action",
            "ligature": "favorite",
            "codepoint": "E87D"
        }, {
            "iconId": "favorite_border",
            "name": "favorite border",
            "groupId": "action",
            "ligature": "favorite_border",
            "codepoint": "E87E"
        }, {
            "iconId": "feedback",
            "name": "feedback",
            "groupId": "action",
            "ligature": "feedback",
            "codepoint": "E87F"
        }, {
            "iconId": "find_in_page",
            "name": "find in page",
            "groupId": "action",
            "ligature": "find_in_page",
            "codepoint": "E880"
        }, {
            "iconId": "find_replace",
            "name": "find replace",
            "groupId": "action",
            "ligature": "find_replace",
            "codepoint": "E881"
        }, {
            "iconId": "fingerprint",
            "name": "fingerprint",
            "groupId": "action",
            "ligature": "fingerprint",
            "codepoint": "E90D"
        }, {
            "iconId": "flight_land",
            "name": "flight land",
            "groupId": "action",
            "ligature": "flight_land",
            "codepoint": "E904"
        }, {
            "iconId": "flight_takeoff",
            "name": "flight takeoff",
            "groupId": "action",
            "ligature": "flight_takeoff",
            "codepoint": "E905"
        }, {
            "iconId": "flip_to_back",
            "name": "flip to back",
            "groupId": "action",
            "ligature": "flip_to_back",
            "codepoint": "E882"
        }, {
            "iconId": "flip_to_front",
            "name": "flip to front",
            "groupId": "action",
            "ligature": "flip_to_front",
            "codepoint": "E883"
        }, {
            "iconId": "g_translate",
            "name": "g translate",
            "groupId": "action",
            "ligature": "g_translate",
            "codepoint": "E927"
        }, {
            "iconId": "gavel",
            "name": "gavel",
            "groupId": "action",
            "ligature": "gavel",
            "codepoint": "E90E"
        }, {
            "iconId": "get_app",
            "name": "get app",
            "groupId": "action",
            "ligature": "get_app",
            "codepoint": "E884"
        }, {
            "iconId": "gif",
            "name": "gif",
            "groupId": "action",
            "ligature": "gif",
            "codepoint": "E908"
        }, {
            "iconId": "grade",
            "name": "grade",
            "groupId": "action",
            "ligature": "grade",
            "codepoint": "E885"
        }, {
            "iconId": "group_work",
            "name": "group work",
            "groupId": "action",
            "ligature": "group_work",
            "codepoint": "E886"
        }, {
            "iconId": "help",
            "name": "help",
            "groupId": "action",
            "ligature": "help",
            "codepoint": "E887"
        }, {
            "iconId": "help_outline",
            "name": "help outline",
            "groupId": "action",
            "ligature": "help_outline",
            "codepoint": "E8FD"
        }, {
            "iconId": "highlight_off",
            "name": "highlight off",
            "groupId": "action",
            "ligature": "highlight_off",
            "codepoint": "E888"
        }, {
            "iconId": "history",
            "name": "history",
            "groupId": "action",
            "ligature": "history",
            "codepoint": "E889"
        }, {
            "iconId": "home",
            "name": "home",
            "groupId": "action",
            "ligature": "home",
            "codepoint": "E88A"
        }, {
            "iconId": "hourglass_empty",
            "name": "hourglass empty",
            "groupId": "action",
            "ligature": "hourglass_empty",
            "codepoint": "E88B"
        }, {
            "iconId": "hourglass_full",
            "name": "hourglass full",
            "groupId": "action",
            "ligature": "hourglass_full",
            "codepoint": "E88C"
        }, {
            "iconId": "http",
            "name": "http",
            "groupId": "action",
            "ligature": "http",
            "codepoint": "E902"
        }, {
            "iconId": "https",
            "name": "https",
            "groupId": "action",
            "ligature": "https",
            "codepoint": "E88D"
        }, {
            "iconId": "important_devices",
            "name": "important devices",
            "groupId": "action",
            "ligature": "important_devices",
            "codepoint": "E912"
        }, {
            "iconId": "info",
            "name": "info",
            "groupId": "action",
            "ligature": "info",
            "codepoint": "E88E"
        }, {
            "iconId": "info_outline",
            "name": "info outline",
            "groupId": "action",
            "ligature": "info_outline",
            "codepoint": "E88F"
        }, {
            "iconId": "input",
            "name": "input",
            "groupId": "action",
            "ligature": "input",
            "codepoint": "E890"
        }, {
            "iconId": "invert_colors",
            "name": "invert colors",
            "groupId": "action",
            "ligature": "invert_colors",
            "codepoint": "E891"
        }, {
            "iconId": "label",
            "name": "label",
            "groupId": "action",
            "ligature": "label",
            "codepoint": "E892"
        }, {
            "iconId": "label_outline",
            "name": "label outline",
            "groupId": "action",
            "ligature": "label_outline",
            "codepoint": "E893"
        }, {
            "iconId": "language",
            "name": "language",
            "groupId": "action",
            "ligature": "language",
            "codepoint": "E894"
        }, {
            "iconId": "launch",
            "name": "launch",
            "groupId": "action",
            "ligature": "launch",
            "codepoint": "E895"
        }, {
            "iconId": "lightbulb_outline",
            "name": "lightbulb outline",
            "groupId": "action",
            "ligature": "lightbulb_outline",
            "codepoint": "E90F"
        }, {
            "iconId": "line_style",
            "name": "line style",
            "groupId": "action",
            "ligature": "line_style",
            "codepoint": "E919"
        }, {
            "iconId": "line_weight",
            "name": "line weight",
            "groupId": "action",
            "ligature": "line_weight",
            "codepoint": "E91A"
        }, {
            "iconId": "list",
            "name": "list",
            "groupId": "action",
            "ligature": "list",
            "codepoint": "E896"
        }, {
            "iconId": "lock",
            "name": "lock",
            "groupId": "action",
            "ligature": "lock",
            "codepoint": "E897"
        }, {
            "iconId": "lock_open",
            "name": "lock open",
            "groupId": "action",
            "ligature": "lock_open",
            "codepoint": "E898"
        }, {
            "iconId": "lock_outline",
            "name": "lock outline",
            "groupId": "action",
            "ligature": "lock_outline",
            "codepoint": "E899"
        }, {
            "iconId": "loyalty",
            "name": "loyalty",
            "groupId": "action",
            "ligature": "loyalty",
            "codepoint": "E89A"
        }, {
            "iconId": "markunread_mailbox",
            "name": "markunread mailbox",
            "groupId": "action",
            "ligature": "markunread_mailbox",
            "codepoint": "E89B"
        }, {
            "iconId": "motorcycle",
            "name": "motorcycle",
            "groupId": "action",
            "ligature": "motorcycle",
            "codepoint": "E91B"
        }, {
            "iconId": "note_add",
            "name": "note add",
            "groupId": "action",
            "ligature": "note_add",
            "codepoint": "E89C"
        }, {
            "iconId": "offline_pin",
            "name": "offline pin",
            "groupId": "action",
            "ligature": "offline_pin",
            "codepoint": "E90A"
        }, {
            "iconId": "opacity",
            "name": "opacity",
            "groupId": "action",
            "ligature": "opacity",
            "codepoint": "E91C"
        }, {
            "iconId": "open_in_browser",
            "name": "open in browser",
            "groupId": "action",
            "ligature": "open_in_browser",
            "codepoint": "E89D"
        }, {
            "iconId": "open_in_new",
            "name": "open in new",
            "groupId": "action",
            "ligature": "open_in_new",
            "codepoint": "E89E"
        }, {
            "iconId": "open_with",
            "name": "open with",
            "groupId": "action",
            "ligature": "open_with",
            "codepoint": "E89F"
        }, {
            "iconId": "pageview",
            "name": "pageview",
            "groupId": "action",
            "ligature": "pageview",
            "codepoint": "E8A0"
        }, {
            "iconId": "pan_tool",
            "name": "pan tool",
            "groupId": "action",
            "ligature": "pan_tool",
            "codepoint": "E925"
        }, {
            "iconId": "payment",
            "name": "payment",
            "groupId": "action",
            "ligature": "payment",
            "codepoint": "E8A1"
        }, {
            "iconId": "perm_camera_mic",
            "name": "perm camera mic",
            "groupId": "action",
            "ligature": "perm_camera_mic",
            "codepoint": "E8A2"
        }, {
            "iconId": "perm_contact_calendar",
            "name": "perm contact calendar",
            "groupId": "action",
            "ligature": "perm_contact_calendar",
            "codepoint": "E8A3"
        }, {
            "iconId": "perm_data_setting",
            "name": "perm data setting",
            "groupId": "action",
            "ligature": "perm_data_setting",
            "codepoint": "E8A4"
        }, {
            "iconId": "perm_device_information",
            "name": "perm device information",
            "groupId": "action",
            "ligature": "perm_device_information",
            "codepoint": "E8A5"
        }, {
            "iconId": "perm_identity",
            "name": "perm identity",
            "groupId": "action",
            "ligature": "perm_identity",
            "codepoint": "E8A6"
        }, {
            "iconId": "perm_media",
            "name": "perm media",
            "groupId": "action",
            "ligature": "perm_media",
            "codepoint": "E8A7"
        }, {
            "iconId": "perm_phone_msg",
            "name": "perm phone msg",
            "groupId": "action",
            "ligature": "perm_phone_msg",
            "codepoint": "E8A8"
        }, {
            "iconId": "perm_scan_wifi",
            "name": "perm scan wifi",
            "groupId": "action",
            "ligature": "perm_scan_wifi",
            "codepoint": "E8A9"
        }, {
            "iconId": "pets",
            "name": "pets",
            "groupId": "action",
            "ligature": "pets",
            "codepoint": "E91D"
        }, {
            "iconId": "picture_in_picture",
            "name": "picture in picture",
            "groupId": "action",
            "ligature": "picture_in_picture",
            "codepoint": "E8AA"
        }, {
            "iconId": "picture_in_picture_alt",
            "name": "picture in picture alt",
            "groupId": "action",
            "ligature": "picture_in_picture_alt",
            "codepoint": "E911"
        }, {
            "iconId": "play_for_work",
            "name": "play for work",
            "groupId": "action",
            "ligature": "play_for_work",
            "codepoint": "E906"
        }, {
            "iconId": "polymer",
            "name": "polymer",
            "groupId": "action",
            "ligature": "polymer",
            "codepoint": "E8AB"
        }, {
            "iconId": "power_settings_new",
            "name": "power settings new",
            "groupId": "action",
            "ligature": "power_settings_new",
            "codepoint": "E8AC"
        }, {
            "iconId": "pregnant_woman",
            "name": "pregnant woman",
            "groupId": "action",
            "ligature": "pregnant_woman",
            "codepoint": "E91E"
        }, {
            "iconId": "print",
            "name": "print",
            "groupId": "action",
            "ligature": "print",
            "codepoint": "E8AD"
        }, {
            "iconId": "query_builder",
            "name": "query builder",
            "groupId": "action",
            "ligature": "query_builder",
            "codepoint": "E8AE"
        }, {
            "iconId": "question_answer",
            "name": "question answer",
            "groupId": "action",
            "ligature": "question_answer",
            "codepoint": "E8AF"
        }, {
            "iconId": "receipt",
            "name": "receipt",
            "groupId": "action",
            "ligature": "receipt",
            "codepoint": "E8B0"
        }, {
            "iconId": "record_voice_over",
            "name": "record voice over",
            "groupId": "action",
            "ligature": "record_voice_over",
            "codepoint": "E91F"
        }, {
            "iconId": "redeem",
            "name": "redeem",
            "groupId": "action",
            "ligature": "redeem",
            "codepoint": "E8B1"
        }, {
            "iconId": "remove_shopping_cart",
            "name": "remove shopping cart",
            "groupId": "action",
            "ligature": "remove_shopping_cart",
            "codepoint": "E928"
        }, {
            "iconId": "reorder",
            "name": "reorder",
            "groupId": "action",
            "ligature": "reorder",
            "codepoint": "E8FE"
        }, {
            "iconId": "report_problem",
            "name": "report problem",
            "groupId": "action",
            "ligature": "report_problem",
            "codepoint": "E8B2"
        }, {
            "iconId": "restore",
            "name": "restore",
            "groupId": "action",
            "ligature": "restore",
            "codepoint": "E8B3"
        }, {
            "iconId": "restore_page",
            "name": "restore page",
            "groupId": "action",
            "ligature": "restore_page",
            "codepoint": "E929"
        }, {
            "iconId": "room",
            "name": "room",
            "groupId": "action",
            "ligature": "room",
            "codepoint": "E8B4"
        }, {
            "iconId": "rounded_corner",
            "name": "rounded corner",
            "groupId": "action",
            "ligature": "rounded_corner",
            "codepoint": "E920"
        }, {
            "iconId": "rowing",
            "name": "rowing",
            "groupId": "action",
            "ligature": "rowing",
            "codepoint": "E921"
        }, {
            "iconId": "schedule",
            "name": "schedule",
            "groupId": "action",
            "ligature": "schedule",
            "codepoint": "E8B5"
        }, {
            "iconId": "search",
            "name": "search",
            "groupId": "action",
            "ligature": "search",
            "codepoint": "E8B6"
        }, {
            "iconId": "settings",
            "name": "settings",
            "groupId": "action",
            "ligature": "settings",
            "codepoint": "E8B8"
        }, {
            "iconId": "settings_applications",
            "name": "settings applications",
            "groupId": "action",
            "ligature": "settings_applications",
            "codepoint": "E8B9"
        }, {
            "iconId": "settings_backup_restore",
            "name": "settings backup restore",
            "groupId": "action",
            "ligature": "settings_backup_restore",
            "codepoint": "E8BA"
        }, {
            "iconId": "settings_bluetooth",
            "name": "settings bluetooth",
            "groupId": "action",
            "ligature": "settings_bluetooth",
            "codepoint": "E8BB"
        }, {
            "iconId": "settings_brightness",
            "name": "settings brightness",
            "groupId": "action",
            "ligature": "settings_brightness",
            "codepoint": "E8BD"
        }, {
            "iconId": "settings_cell",
            "name": "settings cell",
            "groupId": "action",
            "ligature": "settings_cell",
            "codepoint": "E8BC"
        }, {
            "iconId": "settings_ethernet",
            "name": "settings ethernet",
            "groupId": "action",
            "ligature": "settings_ethernet",
            "codepoint": "E8BE"
        }, {
            "iconId": "settings_input_antenna",
            "name": "settings input antenna",
            "groupId": "action",
            "ligature": "settings_input_antenna",
            "codepoint": "E8BF"
        }, {
            "iconId": "settings_input_component",
            "name": "settings input component",
            "groupId": "action",
            "ligature": "settings_input_component",
            "codepoint": "E8C0"
        }, {
            "iconId": "settings_input_composite",
            "name": "settings input composite",
            "groupId": "action",
            "ligature": "settings_input_composite",
            "codepoint": "E8C1"
        }, {
            "iconId": "settings_input_hdmi",
            "name": "settings input hdmi",
            "groupId": "action",
            "ligature": "settings_input_hdmi",
            "codepoint": "E8C2"
        }, {
            "iconId": "settings_input_svideo",
            "name": "settings input svideo",
            "groupId": "action",
            "ligature": "settings_input_svideo",
            "codepoint": "E8C3"
        }, {
            "iconId": "settings_overscan",
            "name": "settings overscan",
            "groupId": "action",
            "ligature": "settings_overscan",
            "codepoint": "E8C4"
        }, {
            "iconId": "settings_phone",
            "name": "settings phone",
            "groupId": "action",
            "ligature": "settings_phone",
            "codepoint": "E8C5"
        }, {
            "iconId": "settings_power",
            "name": "settings power",
            "groupId": "action",
            "ligature": "settings_power",
            "codepoint": "E8C6"
        }, {
            "iconId": "settings_remote",
            "name": "settings remote",
            "groupId": "action",
            "ligature": "settings_remote",
            "codepoint": "E8C7"
        }, {
            "iconId": "settings_voice",
            "name": "settings voice",
            "groupId": "action",
            "ligature": "settings_voice",
            "codepoint": "E8C8"
        }, {
            "iconId": "shop",
            "name": "shop",
            "groupId": "action",
            "ligature": "shop",
            "codepoint": "E8C9"
        }, {
            "iconId": "shop_two",
            "name": "shop two",
            "groupId": "action",
            "ligature": "shop_two",
            "codepoint": "E8CA"
        }, {
            "iconId": "shopping_basket",
            "name": "shopping basket",
            "groupId": "action",
            "ligature": "shopping_basket",
            "codepoint": "E8CB"
        }, {
            "iconId": "shopping_cart",
            "name": "shopping cart",
            "groupId": "action",
            "ligature": "shopping_cart",
            "codepoint": "E8CC"
        }, {
            "iconId": "speaker_notes",
            "name": "speaker notes",
            "groupId": "action",
            "ligature": "speaker_notes",
            "codepoint": "E8CD"
        }, {
            "iconId": "speaker_notes_off",
            "name": "speaker notes off",
            "groupId": "action",
            "ligature": "speaker_notes_off",
            "codepoint": "E92A"
        }, {
            "iconId": "spellcheck",
            "name": "spellcheck",
            "groupId": "action",
            "ligature": "spellcheck",
            "codepoint": "E8CE"
        }, {
            "iconId": "star_rate",
            "name": "star rate",
            "groupId": "action",
            "ligature": "star_rate",
            "codepoint": "E8CF"
        }, {
            "iconId": "stars",
            "name": "stars",
            "groupId": "action",
            "ligature": "stars",
            "codepoint": "E8D0"
        }, {
            "iconId": "store",
            "name": "store",
            "groupId": "action",
            "ligature": "store",
            "codepoint": "E8D1"
        }, {
            "iconId": "subject",
            "name": "subject",
            "groupId": "action",
            "ligature": "subject",
            "codepoint": "E8D2"
        }, {
            "iconId": "supervisor_account",
            "name": "supervisor account",
            "groupId": "action",
            "ligature": "supervisor_account",
            "codepoint": "E8D3"
        }, {
            "iconId": "swap_horiz",
            "name": "swap horiz",
            "groupId": "action",
            "ligature": "swap_horiz",
            "codepoint": "E8D4"
        }, {
            "iconId": "swap_vert",
            "name": "swap vert",
            "groupId": "action",
            "ligature": "swap_vert",
            "codepoint": "E8D5"
        }, {
            "iconId": "swap_vertical_circle",
            "name": "swap vertical circle",
            "groupId": "action",
            "ligature": "swap_vertical_circle",
            "codepoint": "E8D6"
        }, {
            "iconId": "system_update_alt",
            "name": "system update alt",
            "groupId": "action",
            "ligature": "system_update_alt",
            "codepoint": "E8D7"
        }, {
            "iconId": "tab",
            "name": "tab",
            "groupId": "action",
            "ligature": "tab",
            "codepoint": "E8D8"
        }, {
            "iconId": "tab_unselected",
            "name": "tab unselected",
            "groupId": "action",
            "ligature": "tab_unselected",
            "codepoint": "E8D9"
        }, {
            "iconId": "theaters",
            "name": "theaters",
            "groupId": "action",
            "ligature": "theaters",
            "codepoint": "E8DA"
        }, {
            "iconId": "thumb_down",
            "name": "thumb down",
            "groupId": "action",
            "ligature": "thumb_down",
            "codepoint": "E8DB"
        }, {
            "iconId": "thumb_up",
            "name": "thumb up",
            "groupId": "action",
            "ligature": "thumb_up",
            "codepoint": "E8DC"
        }, {
            "iconId": "thumbs_up_down",
            "name": "thumbs up down",
            "groupId": "action",
            "ligature": "thumbs_up_down",
            "codepoint": "E8DD"
        }, {
            "iconId": "timeline",
            "name": "timeline",
            "groupId": "action",
            "ligature": "timeline",
            "codepoint": "E922"
        }, {
            "iconId": "toc",
            "name": "toc",
            "groupId": "action",
            "ligature": "toc",
            "codepoint": "E8DE"
        }, {
            "iconId": "today",
            "name": "today",
            "groupId": "action",
            "ligature": "today",
            "codepoint": "E8DF"
        }, {
            "iconId": "toll",
            "name": "toll",
            "groupId": "action",
            "ligature": "toll",
            "codepoint": "E8E0"
        }, {
            "iconId": "touch_app",
            "name": "touch app",
            "groupId": "action",
            "ligature": "touch_app",
            "codepoint": "E913"
        }, {
            "iconId": "track_changes",
            "name": "track changes",
            "groupId": "action",
            "ligature": "track_changes",
            "codepoint": "E8E1"
        }, {
            "iconId": "translate",
            "name": "translate",
            "groupId": "action",
            "ligature": "translate",
            "codepoint": "E8E2"
        }, {
            "iconId": "trending_down",
            "name": "trending down",
            "groupId": "action",
            "ligature": "trending_down",
            "codepoint": "E8E3"
        }, {
            "iconId": "trending_flat",
            "name": "trending flat",
            "groupId": "action",
            "ligature": "trending_flat",
            "codepoint": "E8E4"
        }, {
            "iconId": "trending_up",
            "name": "trending up",
            "groupId": "action",
            "ligature": "trending_up",
            "codepoint": "E8E5"
        }, {
            "iconId": "turned_in",
            "name": "turned in",
            "groupId": "action",
            "ligature": "turned_in",
            "codepoint": "E8E6"
        }, {
            "iconId": "turned_in_not",
            "name": "turned in not",
            "groupId": "action",
            "ligature": "turned_in_not",
            "codepoint": "E8E7"
        }, {
            "iconId": "update",
            "name": "update",
            "groupId": "action",
            "ligature": "update",
            "codepoint": "E923"
        }, {
            "iconId": "verified_user",
            "name": "verified user",
            "groupId": "action",
            "ligature": "verified_user",
            "codepoint": "E8E8"
        }, {
            "iconId": "view_agenda",
            "name": "view agenda",
            "groupId": "action",
            "ligature": "view_agenda",
            "codepoint": "E8E9"
        }, {
            "iconId": "view_array",
            "name": "view array",
            "groupId": "action",
            "ligature": "view_array",
            "codepoint": "E8EA"
        }, {
            "iconId": "view_carousel",
            "name": "view carousel",
            "groupId": "action",
            "ligature": "view_carousel",
            "codepoint": "E8EB"
        }, {
            "iconId": "view_column",
            "name": "view column",
            "groupId": "action",
            "ligature": "view_column",
            "codepoint": "E8EC"
        }, {
            "iconId": "view_day",
            "name": "view day",
            "groupId": "action",
            "ligature": "view_day",
            "codepoint": "E8ED"
        }, {
            "iconId": "view_headline",
            "name": "view headline",
            "groupId": "action",
            "ligature": "view_headline",
            "codepoint": "E8EE"
        }, {
            "iconId": "view_list",
            "name": "view list",
            "groupId": "action",
            "ligature": "view_list",
            "codepoint": "E8EF"
        }, {
            "iconId": "view_module",
            "name": "view module",
            "groupId": "action",
            "ligature": "view_module",
            "codepoint": "E8F0"
        }, {
            "iconId": "view_quilt",
            "name": "view quilt",
            "groupId": "action",
            "ligature": "view_quilt",
            "codepoint": "E8F1"
        }, {
            "iconId": "view_stream",
            "name": "view stream",
            "groupId": "action",
            "ligature": "view_stream",
            "codepoint": "E8F2"
        }, {
            "iconId": "view_week",
            "name": "view week",
            "groupId": "action",
            "ligature": "view_week",
            "codepoint": "E8F3"
        }, {
            "iconId": "visibility",
            "name": "visibility",
            "groupId": "action",
            "ligature": "visibility",
            "codepoint": "E8F4"
        }, {
            "iconId": "visibility_off",
            "name": "visibility off",
            "groupId": "action",
            "ligature": "visibility_off",
            "codepoint": "E8F5"
        }, {
            "iconId": "watch_later",
            "name": "watch later",
            "groupId": "action",
            "ligature": "watch_later",
            "codepoint": "E924"
        }, {
            "iconId": "work",
            "name": "work",
            "groupId": "action",
            "ligature": "work",
            "codepoint": "E8F9"
        }, {
            "iconId": "youtube_searched_for",
            "name": "youtube searched for",
            "groupId": "action",
            "ligature": "youtube_searched_for",
            "codepoint": "E8FA"
        }, {
            "iconId": "zoom_in",
            "name": "zoom in",
            "groupId": "action",
            "ligature": "zoom_in",
            "codepoint": "E8FF"
        }, {
            "iconId": "zoom_out",
            "name": "zoom out",
            "groupId": "action",
            "ligature": "zoom_out",
            "codepoint": "E900"
        }, {
            "iconId": "add_alert",
            "name": "add alert",
            "groupId": "alert",
            "ligature": "add_alert",
            "codepoint": "E003"
        }, {
            "iconId": "error",
            "name": "error",
            "groupId": "alert",
            "ligature": "error",
            "codepoint": "E000"
        }, {
            "iconId": "error_outline",
            "name": "error outline",
            "groupId": "alert",
            "ligature": "error_outline",
            "codepoint": "E001"
        }, {
            "iconId": "warning",
            "name": "warning",
            "groupId": "alert",
            "ligature": "warning",
            "codepoint": "E002"
        }, {
            "iconId": "add_to_queue",
            "name": "add to queue",
            "groupId": "av",
            "ligature": "add_to_queue",
            "codepoint": "E05C"
        }, {
            "iconId": "airplay",
            "name": "airplay",
            "groupId": "av",
            "ligature": "airplay",
            "codepoint": "E055"
        }, {
            "iconId": "album",
            "name": "album",
            "groupId": "av",
            "ligature": "album",
            "codepoint": "E019"
        }, {
            "iconId": "art_track",
            "name": "art track",
            "groupId": "av",
            "ligature": "art_track",
            "codepoint": "E060"
        }, {
            "iconId": "av_timer",
            "name": "av timer",
            "groupId": "av",
            "ligature": "av_timer",
            "codepoint": "E01B"
        }, {
            "iconId": "branding_watermark",
            "name": "branding watermark",
            "groupId": "av",
            "ligature": "branding_watermark",
            "codepoint": "E06B"
        }, {
            "iconId": "call_to_action",
            "name": "call to action",
            "groupId": "av",
            "ligature": "call_to_action",
            "codepoint": "E06C"
        }, {
            "iconId": "closed_caption",
            "name": "closed caption",
            "groupId": "av",
            "ligature": "closed_caption",
            "codepoint": "E01C"
        }, {
            "iconId": "equalizer",
            "name": "equalizer",
            "groupId": "av",
            "ligature": "equalizer",
            "codepoint": "E01D"
        }, {
            "iconId": "explicit",
            "name": "explicit",
            "groupId": "av",
            "ligature": "explicit",
            "codepoint": "E01E"
        }, {
            "iconId": "fast_forward",
            "name": "fast forward",
            "groupId": "av",
            "ligature": "fast_forward",
            "codepoint": "E01F"
        }, {
            "iconId": "fast_rewind",
            "name": "fast rewind",
            "groupId": "av",
            "ligature": "fast_rewind",
            "codepoint": "E020"
        }, {
            "iconId": "featured_play_list",
            "name": "featured play list",
            "groupId": "av",
            "ligature": "featured_play_list",
            "codepoint": "E06D"
        }, {
            "iconId": "featured_video",
            "name": "featured video",
            "groupId": "av",
            "ligature": "featured_video",
            "codepoint": "E06E"
        }, {
            "iconId": "fiber_dvr",
            "name": "fiber dvr",
            "groupId": "av",
            "ligature": "fiber_dvr",
            "codepoint": "E05D"
        }, {
            "iconId": "fiber_manual_record",
            "name": "fiber manual record",
            "groupId": "av",
            "ligature": "fiber_manual_record",
            "codepoint": "E061"
        }, {
            "iconId": "fiber_new",
            "name": "fiber new",
            "groupId": "av",
            "ligature": "fiber_new",
            "codepoint": "E05E"
        }, {
            "iconId": "fiber_pin",
            "name": "fiber pin",
            "groupId": "av",
            "ligature": "fiber_pin",
            "codepoint": "E06A"
        }, {
            "iconId": "fiber_smart_record",
            "name": "fiber smart record",
            "groupId": "av",
            "ligature": "fiber_smart_record",
            "codepoint": "E062"
        }, {
            "iconId": "forward_10",
            "name": "forward 10",
            "groupId": "av",
            "ligature": "forward_10",
            "codepoint": "E056"
        }, {
            "iconId": "forward_30",
            "name": "forward 30",
            "groupId": "av",
            "ligature": "forward_30",
            "codepoint": "E057"
        }, {
            "iconId": "forward_5",
            "name": "forward 5",
            "groupId": "av",
            "ligature": "forward_5",
            "codepoint": "E058"
        }, {
            "iconId": "games",
            "name": "games",
            "groupId": "av",
            "ligature": "games",
            "codepoint": "E021"
        }, {
            "iconId": "hd",
            "name": "hd",
            "groupId": "av",
            "ligature": "hd",
            "codepoint": "E052"
        }, {
            "iconId": "hearing",
            "name": "hearing",
            "groupId": "av",
            "ligature": "hearing",
            "codepoint": "E023"
        }, {
            "iconId": "high_quality",
            "name": "high quality",
            "groupId": "av",
            "ligature": "high_quality",
            "codepoint": "E024"
        }, {
            "iconId": "library_add",
            "name": "library add",
            "groupId": "av",
            "ligature": "library_add",
            "codepoint": "E02E"
        }, {
            "iconId": "library_books",
            "name": "library books",
            "groupId": "av",
            "ligature": "library_books",
            "codepoint": "E02F"
        }, {
            "iconId": "library_music",
            "name": "library music",
            "groupId": "av",
            "ligature": "library_music",
            "codepoint": "E030"
        }, {
            "iconId": "loop",
            "name": "loop",
            "groupId": "av",
            "ligature": "loop",
            "codepoint": "E028"
        }, {
            "iconId": "mic",
            "name": "mic",
            "groupId": "av",
            "ligature": "mic",
            "codepoint": "E029"
        }, {
            "iconId": "mnone",
            "name": "mic none",
            "groupId": "av",
            "ligature": "mnone",
            "codepoint": "E02A"
        }, {
            "iconId": "moff",
            "name": "mic off",
            "groupId": "av",
            "ligature": "moff",
            "codepoint": "E02B"
        }, {
            "iconId": "movie",
            "name": "movie",
            "groupId": "av",
            "ligature": "movie",
            "codepoint": "E02C"
        }, {
            "iconId": "musvideo",
            "name": "music video",
            "groupId": "av",
            "ligature": "musvideo",
            "codepoint": "E063"
        }, {
            "iconId": "new_releases",
            "name": "new releases",
            "groupId": "av",
            "ligature": "new_releases",
            "codepoint": "E031"
        }, {
            "iconId": "not_interested",
            "name": "not interested",
            "groupId": "av",
            "ligature": "not_interested",
            "codepoint": "E033"
        }, {
            "iconId": "note",
            "name": "note",
            "groupId": "av",
            "ligature": "note",
            "codepoint": "E06F"
        }, {
            "iconId": "pause",
            "name": "pause",
            "groupId": "av",
            "ligature": "pause",
            "codepoint": "E034"
        }, {
            "iconId": "pause_circle_filled",
            "name": "pause circle filled",
            "groupId": "av",
            "ligature": "pause_circle_filled",
            "codepoint": "E035"
        }, {
            "iconId": "pause_circle_outline",
            "name": "pause circle outline",
            "groupId": "av",
            "ligature": "pause_circle_outline",
            "codepoint": "E036"
        }, {
            "iconId": "play_arrow",
            "name": "play arrow",
            "groupId": "av",
            "ligature": "play_arrow",
            "codepoint": "E037"
        }, {
            "iconId": "play_circle_filled",
            "name": "play circle filled",
            "groupId": "av",
            "ligature": "play_circle_filled",
            "codepoint": "E038"
        }, {
            "iconId": "play_circle_outline",
            "name": "play circle outline",
            "groupId": "av",
            "ligature": "play_circle_outline",
            "codepoint": "E039"
        }, {
            "iconId": "playlist_add",
            "name": "playlist add",
            "groupId": "av",
            "ligature": "playlist_add",
            "codepoint": "E03B"
        }, {
            "iconId": "playlist_add_check",
            "name": "playlist add check",
            "groupId": "av",
            "ligature": "playlist_add_check",
            "codepoint": "E065"
        }, {
            "iconId": "playlist_play",
            "name": "playlist play",
            "groupId": "av",
            "ligature": "playlist_play",
            "codepoint": "E05F"
        }, {
            "iconId": "queue",
            "name": "queue",
            "groupId": "av",
            "ligature": "queue",
            "codepoint": "E03C"
        }, {
            "iconId": "queue_music",
            "name": "queue music",
            "groupId": "av",
            "ligature": "queue_music",
            "codepoint": "E03D"
        }, {
            "iconId": "queue_play_next",
            "name": "queue play next",
            "groupId": "av",
            "ligature": "queue_play_next",
            "codepoint": "E066"
        }, {
            "iconId": "radio",
            "name": "radio",
            "groupId": "av",
            "ligature": "radio",
            "codepoint": "E03E"
        }, {
            "iconId": "recent_actors",
            "name": "recent actors",
            "groupId": "av",
            "ligature": "recent_actors",
            "codepoint": "E03F"
        }, {
            "iconId": "remove_from_queue",
            "name": "remove from queue",
            "groupId": "av",
            "ligature": "remove_from_queue",
            "codepoint": "E067"
        }, {
            "iconId": "repeat",
            "name": "repeat",
            "groupId": "av",
            "ligature": "repeat",
            "codepoint": "E040"
        }, {
            "iconId": "repeat_one",
            "name": "repeat one",
            "groupId": "av",
            "ligature": "repeat_one",
            "codepoint": "E041"
        }, {
            "iconId": "replay",
            "name": "replay",
            "groupId": "av",
            "ligature": "replay",
            "codepoint": "E042"
        }, {
            "iconId": "replay_10",
            "name": "replay 10",
            "groupId": "av",
            "ligature": "replay_10",
            "codepoint": "E059"
        }, {
            "iconId": "replay_30",
            "name": "replay 30",
            "groupId": "av",
            "ligature": "replay_30",
            "codepoint": "E05A"
        }, {
            "iconId": "replay_5",
            "name": "replay 5",
            "groupId": "av",
            "ligature": "replay_5",
            "codepoint": "E05B"
        }, {
            "iconId": "shuffle",
            "name": "shuffle",
            "groupId": "av",
            "ligature": "shuffle",
            "codepoint": "E043"
        }, {
            "iconId": "skip_next",
            "name": "skip next",
            "groupId": "av",
            "ligature": "skip_next",
            "codepoint": "E044"
        }, {
            "iconId": "skip_previous",
            "name": "skip previous",
            "groupId": "av",
            "ligature": "skip_previous",
            "codepoint": "E045"
        }, {
            "iconId": "slow_motion_video",
            "name": "slow motion video",
            "groupId": "av",
            "ligature": "slow_motion_video",
            "codepoint": "E068"
        }, {
            "iconId": "snooze",
            "name": "snooze",
            "groupId": "av",
            "ligature": "snooze",
            "codepoint": "E046"
        }, {
            "iconId": "sort_by_alpha",
            "name": "sort by alpha",
            "groupId": "av",
            "ligature": "sort_by_alpha",
            "codepoint": "E053"
        }, {
            "iconId": "stop",
            "name": "stop",
            "groupId": "av",
            "ligature": "stop",
            "codepoint": "E047"
        }, {
            "iconId": "subscriptions",
            "name": "subscriptions",
            "groupId": "av",
            "ligature": "subscriptions",
            "codepoint": "E064"
        }, {
            "iconId": "subtitles",
            "name": "subtitles",
            "groupId": "av",
            "ligature": "subtitles",
            "codepoint": "E048"
        }, {
            "iconId": "surround_sound",
            "name": "surround sound",
            "groupId": "av",
            "ligature": "surround_sound",
            "codepoint": "E049"
        }, {
            "iconId": "video_call",
            "name": "video call",
            "groupId": "av",
            "ligature": "video_call",
            "codepoint": "E070"
        }, {
            "iconId": "video_label",
            "name": "video label",
            "groupId": "av",
            "ligature": "video_label",
            "codepoint": "E071"
        }, {
            "iconId": "video_library",
            "name": "video library",
            "groupId": "av",
            "ligature": "video_library",
            "codepoint": "E04A"
        }, {
            "iconId": "videocam",
            "name": "videocam",
            "groupId": "av",
            "ligature": "videocam",
            "codepoint": "E04B"
        }, {
            "iconId": "videocam_off",
            "name": "videocam off",
            "groupId": "av",
            "ligature": "videocam_off",
            "codepoint": "E04C"
        }, {
            "iconId": "volume_down",
            "name": "volume down",
            "groupId": "av",
            "ligature": "volume_down",
            "codepoint": "E04D"
        }, {
            "iconId": "volume_mute",
            "name": "volume mute",
            "groupId": "av",
            "ligature": "volume_mute",
            "codepoint": "E04E"
        }, {
            "iconId": "volume_off",
            "name": "volume off",
            "groupId": "av",
            "ligature": "volume_off",
            "codepoint": "E04F"
        }, {
            "iconId": "volume_up",
            "name": "volume up",
            "groupId": "av",
            "ligature": "volume_up",
            "codepoint": "E050"
        }, {
            "iconId": "web",
            "name": "web",
            "groupId": "av",
            "ligature": "web",
            "codepoint": "E051"
        }, {
            "iconId": "web_asset",
            "name": "web asset",
            "groupId": "av",
            "ligature": "web_asset",
            "codepoint": "E069"
        }, {
            "iconId": "business",
            "name": "business",
            "groupId": "communication",
            "ligature": "business",
            "codepoint": "E0AF"
        }, {
            "iconId": "call",
            "name": "call",
            "groupId": "communication",
            "ligature": "call",
            "codepoint": "E0B0"
        }, {
            "iconId": "call_end",
            "name": "call end",
            "groupId": "communication",
            "ligature": "call_end",
            "codepoint": "E0B1"
        }, {
            "iconId": "call_made",
            "name": "call made",
            "groupId": "communication",
            "ligature": "call_made",
            "codepoint": "E0B2"
        }, {
            "iconId": "call_merge",
            "name": "call merge",
            "groupId": "communication",
            "ligature": "call_merge",
            "codepoint": "E0B3"
        }, {
            "iconId": "call_missed",
            "name": "call missed",
            "groupId": "communication",
            "ligature": "call_missed",
            "codepoint": "E0B4"
        }, {
            "iconId": "call_missed_outgoing",
            "name": "call missed outgoing",
            "groupId": "communication",
            "ligature": "call_missed_outgoing",
            "codepoint": "E0E4"
        }, {
            "iconId": "call_received",
            "name": "call received",
            "groupId": "communication",
            "ligature": "call_received",
            "codepoint": "E0B5"
        }, {
            "iconId": "call_split",
            "name": "call split",
            "groupId": "communication",
            "ligature": "call_split",
            "codepoint": "E0B6"
        }, {
            "iconId": "chat",
            "name": "chat",
            "groupId": "communication",
            "ligature": "chat",
            "codepoint": "E0B7"
        }, {
            "iconId": "chat_bubble",
            "name": "chat bubble",
            "groupId": "communication",
            "ligature": "chat_bubble",
            "codepoint": "E0CA"
        }, {
            "iconId": "chat_bubble_outline",
            "name": "chat bubble outline",
            "groupId": "communication",
            "ligature": "chat_bubble_outline",
            "codepoint": "E0CB"
        }, {
            "iconId": "clear_all",
            "name": "clear all",
            "groupId": "communication",
            "ligature": "clear_all",
            "codepoint": "E0B8"
        }, {
            "iconId": "comment",
            "name": "comment",
            "groupId": "communication",
            "ligature": "comment",
            "codepoint": "E0B9"
        }, {
            "iconId": "contact_mail",
            "name": "contact mail",
            "groupId": "communication",
            "ligature": "contact_mail",
            "codepoint": "E0D0"
        }, {
            "iconId": "contact_phone",
            "name": "contact phone",
            "groupId": "communication",
            "ligature": "contact_phone",
            "codepoint": "E0CF"
        }, {
            "iconId": "contacts",
            "name": "contacts",
            "groupId": "communication",
            "ligature": "contacts",
            "codepoint": "E0BA"
        }, {
            "iconId": "dialer_sip",
            "name": "dialer sip",
            "groupId": "communication",
            "ligature": "dialer_sip",
            "codepoint": "E0BB"
        }, {
            "iconId": "dialpad",
            "name": "dialpad",
            "groupId": "communication",
            "ligature": "dialpad",
            "codepoint": "E0BC"
        }, {
            "iconId": "email",
            "name": "email",
            "groupId": "communication",
            "ligature": "email",
            "codepoint": "E0BE"
        }, {
            "iconId": "forum",
            "name": "forum",
            "groupId": "communication",
            "ligature": "forum",
            "codepoint": "E0BF"
        }, {
            "iconId": "import_contacts",
            "name": "import contacts",
            "groupId": "communication",
            "ligature": "import_contacts",
            "codepoint": "E0E0"
        }, {
            "iconId": "import_export",
            "name": "import export",
            "groupId": "communication",
            "ligature": "import_export",
            "codepoint": "E0C3"
        }, {
            "iconId": "invert_colors_off",
            "name": "invert colors off",
            "groupId": "communication",
            "ligature": "invert_colors_off",
            "codepoint": "E0C4"
        }, {
            "iconId": "live_help",
            "name": "live help",
            "groupId": "communication",
            "ligature": "live_help",
            "codepoint": "E0C6"
        }, {
            "iconId": "location_off",
            "name": "location off",
            "groupId": "communication",
            "ligature": "location_off",
            "codepoint": "E0C7"
        }, {
            "iconId": "location_on",
            "name": "location on",
            "groupId": "communication",
            "ligature": "location_on",
            "codepoint": "E0C8"
        }, {
            "iconId": "mail_outline",
            "name": "mail outline",
            "groupId": "communication",
            "ligature": "mail_outline",
            "codepoint": "E0E1"
        }, {
            "iconId": "message",
            "name": "message",
            "groupId": "communication",
            "ligature": "message",
            "codepoint": "E0C9"
        }, {
            "iconId": "no_sim",
            "name": "no sim",
            "groupId": "communication",
            "ligature": "no_sim",
            "codepoint": "E0CC"
        }, {
            "iconId": "phone",
            "name": "phone",
            "groupId": "communication",
            "ligature": "phone",
            "codepoint": "E0CD"
        }, {
            "iconId": "phonelink_erase",
            "name": "phonelink erase",
            "groupId": "communication",
            "ligature": "phonelink_erase",
            "codepoint": "E0DB"
        }, {
            "iconId": "phonelink_lock",
            "name": "phonelink lock",
            "groupId": "communication",
            "ligature": "phonelink_lock",
            "codepoint": "E0DC"
        }, {
            "iconId": "phonelink_ring",
            "name": "phonelink ring",
            "groupId": "communication",
            "ligature": "phonelink_ring",
            "codepoint": "E0DD"
        }, {
            "iconId": "phonelink_setup",
            "name": "phonelink setup",
            "groupId": "communication",
            "ligature": "phonelink_setup",
            "codepoint": "E0DE"
        }, {
            "iconId": "portable_wifi_off",
            "name": "portable wifi off",
            "groupId": "communication",
            "ligature": "portable_wifi_off",
            "codepoint": "E0CE"
        }, {
            "iconId": "present_to_all",
            "name": "present to all",
            "groupId": "communication",
            "ligature": "present_to_all",
            "codepoint": "E0DF"
        }, {
            "iconId": "ring_volume",
            "name": "ring volume",
            "groupId": "communication",
            "ligature": "ring_volume",
            "codepoint": "E0D1"
        }, {
            "iconId": "rss_feed",
            "name": "rss feed",
            "groupId": "communication",
            "ligature": "rss_feed",
            "codepoint": "E0E5"
        }, {
            "iconId": "screen_share",
            "name": "screen share",
            "groupId": "communication",
            "ligature": "screen_share",
            "codepoint": "E0E2"
        }, {
            "iconId": "speaker_phone",
            "name": "speaker phone",
            "groupId": "communication",
            "ligature": "speaker_phone",
            "codepoint": "E0D2"
        }, {
            "iconId": "stay_current_landscape",
            "name": "stay current landscape",
            "groupId": "communication",
            "ligature": "stay_current_landscape",
            "codepoint": "E0D3"
        }, {
            "iconId": "stay_current_portrait",
            "name": "stay current portrait",
            "groupId": "communication",
            "ligature": "stay_current_portrait",
            "codepoint": "E0D4"
        }, {
            "iconId": "stay_primary_landscape",
            "name": "stay primary landscape",
            "groupId": "communication",
            "ligature": "stay_primary_landscape",
            "codepoint": "E0D5"
        }, {
            "iconId": "stay_primary_portrait",
            "name": "stay primary portrait",
            "groupId": "communication",
            "ligature": "stay_primary_portrait",
            "codepoint": "E0D6"
        }, {
            "iconId": "stop_screen_share",
            "name": "stop screen share",
            "groupId": "communication",
            "ligature": "stop_screen_share",
            "codepoint": "E0E3"
        }, {
            "iconId": "swap_calls",
            "name": "swap calls",
            "groupId": "communication",
            "ligature": "swap_calls",
            "codepoint": "E0D7"
        }, {
            "iconId": "textsms",
            "name": "textsms",
            "groupId": "communication",
            "ligature": "textsms",
            "codepoint": "E0D8"
        }, {
            "iconId": "voicemail",
            "name": "voicemail",
            "groupId": "communication",
            "ligature": "voicemail",
            "codepoint": "E0D9"
        }, {
            "iconId": "vpn_key",
            "name": "vpn key",
            "groupId": "communication",
            "ligature": "vpn_key",
            "codepoint": "E0DA"
        }, {
            "iconId": "add",
            "name": "add",
            "groupId": "content",
            "ligature": "add",
            "codepoint": "E145"
        }, {
            "iconId": "add_box",
            "name": "add box",
            "groupId": "content",
            "ligature": "add_box",
            "codepoint": "E146"
        }, {
            "iconId": "add_circle",
            "name": "add circle",
            "groupId": "content",
            "ligature": "add_circle",
            "codepoint": "E147"
        }, {
            "iconId": "add_circle_outline",
            "name": "add circle outline",
            "groupId": "content",
            "ligature": "add_circle_outline",
            "codepoint": "E148"
        }, {
            "iconId": "archive",
            "name": "archive",
            "groupId": "content",
            "ligature": "archive",
            "codepoint": "E149"
        }, {
            "iconId": "backspace",
            "name": "backspace",
            "groupId": "content",
            "ligature": "backspace",
            "codepoint": "E14A"
        }, {
            "iconId": "block",
            "name": "block",
            "groupId": "content",
            "ligature": "block",
            "codepoint": "E14B"
        }, {
            "iconId": "clear",
            "name": "clear",
            "groupId": "content",
            "ligature": "clear",
            "codepoint": "E14C"
        }, {
            "iconId": "content_copy",
            "name": "content copy",
            "groupId": "content",
            "ligature": "content_copy",
            "codepoint": "E14D"
        }, {
            "iconId": "content_cut",
            "name": "content cut",
            "groupId": "content",
            "ligature": "content_cut",
            "codepoint": "E14E"
        }, {
            "iconId": "content_paste",
            "name": "content paste",
            "groupId": "content",
            "ligature": "content_paste",
            "codepoint": "E14F"
        }, {
            "iconId": "create",
            "name": "create",
            "groupId": "content",
            "ligature": "create",
            "codepoint": "E150"
        }, {
            "iconId": "delete_sweep",
            "name": "delete sweep",
            "groupId": "content",
            "ligature": "delete_sweep",
            "codepoint": "E16C"
        }, {
            "iconId": "drafts",
            "name": "drafts",
            "groupId": "content",
            "ligature": "drafts",
            "codepoint": "E151"
        }, {
            "iconId": "filter_list",
            "name": "filter list",
            "groupId": "content",
            "ligature": "filter_list",
            "codepoint": "E152"
        }, {
            "iconId": "flag",
            "name": "flag",
            "groupId": "content",
            "ligature": "flag",
            "codepoint": "E153"
        }, {
            "iconId": "font_download",
            "name": "font download",
            "groupId": "content",
            "ligature": "font_download",
            "codepoint": "E167"
        }, {
            "iconId": "forward",
            "name": "forward",
            "groupId": "content",
            "ligature": "forward",
            "codepoint": "E154"
        }, {
            "iconId": "gesture",
            "name": "gesture",
            "groupId": "content",
            "ligature": "gesture",
            "codepoint": "E155"
        }, {
            "iconId": "inbox",
            "name": "inbox",
            "groupId": "content",
            "ligature": "inbox",
            "codepoint": "E156"
        }, {
            "iconId": "link",
            "name": "link",
            "groupId": "content",
            "ligature": "link",
            "codepoint": "E157"
        }, {
            "iconId": "low_priority",
            "name": "low priority",
            "groupId": "content",
            "ligature": "low_priority",
            "codepoint": "E16D"
        }, {
            "iconId": "mail",
            "name": "mail",
            "groupId": "content",
            "ligature": "mail",
            "codepoint": "E158"
        }, {
            "iconId": "markunread",
            "name": "markunread",
            "groupId": "content",
            "ligature": "markunread",
            "codepoint": "E159"
        }, {
            "iconId": "move_to_inbox",
            "name": "move to inbox",
            "groupId": "content",
            "ligature": "move_to_inbox",
            "codepoint": "E168"
        }, {
            "iconId": "next_week",
            "name": "next week",
            "groupId": "content",
            "ligature": "next_week",
            "codepoint": "E16A"
        }, {
            "iconId": "redo",
            "name": "redo",
            "groupId": "content",
            "ligature": "redo",
            "codepoint": "E15A"
        }, {
            "iconId": "remove",
            "name": "remove",
            "groupId": "content",
            "ligature": "remove",
            "codepoint": "E15B"
        }, {
            "iconId": "remove_circle",
            "name": "remove circle",
            "groupId": "content",
            "ligature": "remove_circle",
            "codepoint": "E15C"
        }, {
            "iconId": "remove_circle_outline",
            "name": "remove circle outline",
            "groupId": "content",
            "ligature": "remove_circle_outline",
            "codepoint": "E15D"
        }, {
            "iconId": "reply",
            "name": "reply",
            "groupId": "content",
            "ligature": "reply",
            "codepoint": "E15E"
        }, {
            "iconId": "reply_all",
            "name": "reply all",
            "groupId": "content",
            "ligature": "reply_all",
            "codepoint": "E15F"
        }, {
            "iconId": "report",
            "name": "report",
            "groupId": "content",
            "ligature": "report",
            "codepoint": "E160"
        }, {
            "iconId": "save",
            "name": "save",
            "groupId": "content",
            "ligature": "save",
            "codepoint": "E161"
        }, {
            "iconId": "select_all",
            "name": "select all",
            "groupId": "content",
            "ligature": "select_all",
            "codepoint": "E162"
        }, {
            "iconId": "send",
            "name": "send",
            "groupId": "content",
            "ligature": "send",
            "codepoint": "E163"
        }, {
            "iconId": "sort",
            "name": "sort",
            "groupId": "content",
            "ligature": "sort",
            "codepoint": "E164"
        }, {
            "iconId": "text_format",
            "name": "text format",
            "groupId": "content",
            "ligature": "text_format",
            "codepoint": "E165"
        }, {
            "iconId": "unarchive",
            "name": "unarchive",
            "groupId": "content",
            "ligature": "unarchive",
            "codepoint": "E169"
        }, {
            "iconId": "undo",
            "name": "undo",
            "groupId": "content",
            "ligature": "undo",
            "codepoint": "E166"
        }, {
            "iconId": "weekend",
            "name": "weekend",
            "groupId": "content",
            "ligature": "weekend",
            "codepoint": "E16B"
        }, {
            "iconId": "access_alarm",
            "name": "access alarm",
            "groupId": "device",
            "ligature": "access_alarm",
            "codepoint": "E190"
        }, {
            "iconId": "access_alarms",
            "name": "access alarms",
            "groupId": "device",
            "ligature": "access_alarms",
            "codepoint": "E191"
        }, {
            "iconId": "access_time",
            "name": "access time",
            "groupId": "device",
            "ligature": "access_time",
            "codepoint": "E192"
        }, {
            "iconId": "add_alarm",
            "name": "add alarm",
            "groupId": "device",
            "ligature": "add_alarm",
            "codepoint": "E193"
        }, {
            "iconId": "airplanemode_active",
            "name": "airplanemode active",
            "groupId": "device",
            "ligature": "airplanemode_active",
            "codepoint": "E195"
        }, {
            "iconId": "airplanemode_inactive",
            "name": "airplanemode inactive",
            "groupId": "device",
            "ligature": "airplanemode_inactive",
            "codepoint": "E194"
        }, {
            "iconId": "battery_alert",
            "name": "battery alert",
            "groupId": "device",
            "ligature": "battery_alert",
            "codepoint": "E19C"
        }, {
            "iconId": "battery_charging_full",
            "name": "battery charging full",
            "groupId": "device",
            "ligature": "battery_charging_full",
            "codepoint": "E1A3"
        }, {
            "iconId": "battery_full",
            "name": "battery full",
            "groupId": "device",
            "ligature": "battery_full",
            "codepoint": "E1A4"
        }, {
            "iconId": "battery_std",
            "name": "battery std",
            "groupId": "device",
            "ligature": "battery_std",
            "codepoint": "E1A5"
        }, {
            "iconId": "battery_unknown",
            "name": "battery unknown",
            "groupId": "device",
            "ligature": "battery_unknown",
            "codepoint": "E1A6"
        }, {
            "iconId": "bluetooth",
            "name": "bluetooth",
            "groupId": "device",
            "ligature": "bluetooth",
            "codepoint": "E1A7"
        }, {
            "iconId": "bluetooth_connected",
            "name": "bluetooth connected",
            "groupId": "device",
            "ligature": "bluetooth_connected",
            "codepoint": "E1A8"
        }, {
            "iconId": "bluetooth_disabled",
            "name": "bluetooth disabled",
            "groupId": "device",
            "ligature": "bluetooth_disabled",
            "codepoint": "E1A9"
        }, {
            "iconId": "bluetooth_searching",
            "name": "bluetooth searching",
            "groupId": "device",
            "ligature": "bluetooth_searching",
            "codepoint": "E1AA"
        }, {
            "iconId": "brightness_auto",
            "name": "brightness auto",
            "groupId": "device",
            "ligature": "brightness_auto",
            "codepoint": "E1AB"
        }, {
            "iconId": "brightness_high",
            "name": "brightness high",
            "groupId": "device",
            "ligature": "brightness_high",
            "codepoint": "E1AC"
        }, {
            "iconId": "brightness_low",
            "name": "brightness low",
            "groupId": "device",
            "ligature": "brightness_low",
            "codepoint": "E1AD"
        }, {
            "iconId": "brightness_medium",
            "name": "brightness medium",
            "groupId": "device",
            "ligature": "brightness_medium",
            "codepoint": "E1AE"
        }, {
            "iconId": "data_usage",
            "name": "data usage",
            "groupId": "device",
            "ligature": "data_usage",
            "codepoint": "E1AF"
        }, {
            "iconId": "developer_mode",
            "name": "developer mode",
            "groupId": "device",
            "ligature": "developer_mode",
            "codepoint": "E1B0"
        }, {
            "iconId": "devices",
            "name": "devices",
            "groupId": "device",
            "ligature": "devices",
            "codepoint": "E1B1"
        }, {
            "iconId": "dvr",
            "name": "dvr",
            "groupId": "device",
            "ligature": "dvr",
            "codepoint": "E1B2"
        }, {
            "iconId": "gps_fixed",
            "name": "gps fixed",
            "groupId": "device",
            "ligature": "gps_fixed",
            "codepoint": "E1B3"
        }, {
            "iconId": "gps_not_fixed",
            "name": "gps not fixed",
            "groupId": "device",
            "ligature": "gps_not_fixed",
            "codepoint": "E1B4"
        }, {
            "iconId": "gps_off",
            "name": "gps off",
            "groupId": "device",
            "ligature": "gps_off",
            "codepoint": "E1B5"
        }, {
            "iconId": "grapheq",
            "name": "graphic eq",
            "groupId": "device",
            "ligature": "grapheq",
            "codepoint": "E1B8"
        }, {
            "iconId": "location_disabled",
            "name": "location disabled",
            "groupId": "device",
            "ligature": "location_disabled",
            "codepoint": "E1B6"
        }, {
            "iconId": "location_searching",
            "name": "location searching",
            "groupId": "device",
            "ligature": "location_searching",
            "codepoint": "E1B7"
        }, {
            "iconId": "network_cell",
            "name": "network cell",
            "groupId": "device",
            "ligature": "network_cell",
            "codepoint": "E1B9"
        }, {
            "iconId": "network_wifi",
            "name": "network wifi",
            "groupId": "device",
            "ligature": "network_wifi",
            "codepoint": "E1BA"
        }, {
            "iconId": "nfc",
            "name": "nfc",
            "groupId": "device",
            "ligature": "nfc",
            "codepoint": "E1BB"
        }, {
            "iconId": "screen_lock_landscape",
            "name": "screen lock landscape",
            "groupId": "device",
            "ligature": "screen_lock_landscape",
            "codepoint": "E1BE"
        }, {
            "iconId": "screen_lock_portrait",
            "name": "screen lock portrait",
            "groupId": "device",
            "ligature": "screen_lock_portrait",
            "codepoint": "E1BF"
        }, {
            "iconId": "screen_lock_rotation",
            "name": "screen lock rotation",
            "groupId": "device",
            "ligature": "screen_lock_rotation",
            "codepoint": "E1C0"
        }, {
            "iconId": "screen_rotation",
            "name": "screen rotation",
            "groupId": "device",
            "ligature": "screen_rotation",
            "codepoint": "E1C1"
        }, {
            "iconId": "sd_storage",
            "name": "sd storage",
            "groupId": "device",
            "ligature": "sd_storage",
            "codepoint": "E1C2"
        }, {
            "iconId": "settings_system_daydream",
            "name": "settings system daydream",
            "groupId": "device",
            "ligature": "settings_system_daydream",
            "codepoint": "E1C3"
        }, {
            "iconId": "signal_cellular_4_bar",
            "name": "signal cellular 4 bar",
            "groupId": "device",
            "ligature": "signal_cellular_4_bar",
            "codepoint": "E1C8"
        }, {
            "iconId": "signal_cellular_connected_no_internet_4_bar",
            "name": "signal cellular connected no internet 4 bar",
            "groupId": "device",
            "ligature": "signal_cellular_connected_no_internet_4_bar",
            "codepoint": "E1CD"
        }, {
            "iconId": "signal_cellular_no_sim",
            "name": "signal cellular no sim",
            "groupId": "device",
            "ligature": "signal_cellular_no_sim",
            "codepoint": "E1CE"
        }, {
            "iconId": "signal_cellular_null",
            "name": "signal cellular null",
            "groupId": "device",
            "ligature": "signal_cellular_null",
            "codepoint": "E1CF"
        }, {
            "iconId": "signal_cellular_off",
            "name": "signal cellular off",
            "groupId": "device",
            "ligature": "signal_cellular_off",
            "codepoint": "E1D0"
        }, {
            "iconId": "signal_wifi_4_bar",
            "name": "signal wifi 4 bar",
            "groupId": "device",
            "ligature": "signal_wifi_4_bar",
            "codepoint": "E1D8"
        }, {
            "iconId": "signal_wifi_4_bar_lock",
            "name": "signal wifi 4 bar lock",
            "groupId": "device",
            "ligature": "signal_wifi_4_bar_lock",
            "codepoint": "E1D9"
        }, {
            "iconId": "signal_wifi_off",
            "name": "signal wifi off",
            "groupId": "device",
            "ligature": "signal_wifi_off",
            "codepoint": "E1DA"
        }, {
            "iconId": "storage",
            "name": "storage",
            "groupId": "device",
            "ligature": "storage",
            "codepoint": "E1DB"
        }, {
            "iconId": "usb",
            "name": "usb",
            "groupId": "device",
            "ligature": "usb",
            "codepoint": "E1E0"
        }, {
            "iconId": "wallpaper",
            "name": "wallpaper",
            "groupId": "device",
            "ligature": "wallpaper",
            "codepoint": "E1BC"
        }, {
            "iconId": "widgets",
            "name": "widgets",
            "groupId": "device",
            "ligature": "widgets",
            "codepoint": "E1BD"
        }, {
            "iconId": "wifi_lock",
            "name": "wifi lock",
            "groupId": "device",
            "ligature": "wifi_lock",
            "codepoint": "E1E1"
        }, {
            "iconId": "wifi_tethering",
            "name": "wifi tethering",
            "groupId": "device",
            "ligature": "wifi_tethering",
            "codepoint": "E1E2"
        }, {
            "iconId": "attach_file",
            "name": "attach file",
            "groupId": "editor",
            "ligature": "attach_file",
            "codepoint": "E226"
        }, {
            "iconId": "attach_money",
            "name": "attach money",
            "groupId": "editor",
            "ligature": "attach_money",
            "codepoint": "E227"
        }, {
            "iconId": "border_all",
            "name": "border all",
            "groupId": "editor",
            "ligature": "border_all",
            "codepoint": "E228"
        }, {
            "iconId": "border_bottom",
            "name": "border bottom",
            "groupId": "editor",
            "ligature": "border_bottom",
            "codepoint": "E229"
        }, {
            "iconId": "border_clear",
            "name": "border clear",
            "groupId": "editor",
            "ligature": "border_clear",
            "codepoint": "E22A"
        }, {
            "iconId": "border_color",
            "name": "border color",
            "groupId": "editor",
            "ligature": "border_color",
            "codepoint": "E22B"
        }, {
            "iconId": "border_horizontal",
            "name": "border horizontal",
            "groupId": "editor",
            "ligature": "border_horizontal",
            "codepoint": "E22C"
        }, {
            "iconId": "border_inner",
            "name": "border inner",
            "groupId": "editor",
            "ligature": "border_inner",
            "codepoint": "E22D"
        }, {
            "iconId": "border_left",
            "name": "border left",
            "groupId": "editor",
            "ligature": "border_left",
            "codepoint": "E22E"
        }, {
            "iconId": "border_outer",
            "name": "border outer",
            "groupId": "editor",
            "ligature": "border_outer",
            "codepoint": "E22F"
        }, {
            "iconId": "border_right",
            "name": "border right",
            "groupId": "editor",
            "ligature": "border_right",
            "codepoint": "E230"
        }, {
            "iconId": "border_style",
            "name": "border style",
            "groupId": "editor",
            "ligature": "border_style",
            "codepoint": "E231"
        }, {
            "iconId": "border_top",
            "name": "border top",
            "groupId": "editor",
            "ligature": "border_top",
            "codepoint": "E232"
        }, {
            "iconId": "border_vertical",
            "name": "border vertical",
            "groupId": "editor",
            "ligature": "border_vertical",
            "codepoint": "E233"
        }, {
            "iconId": "bubble_chart",
            "name": "bubble chart",
            "groupId": "editor",
            "ligature": "bubble_chart",
            "codepoint": "E6DD"
        }, {
            "iconId": "drag_handle",
            "name": "drag handle",
            "groupId": "editor",
            "ligature": "drag_handle",
            "codepoint": "E25D"
        }, {
            "iconId": "format_align_center",
            "name": "format align center",
            "groupId": "editor",
            "ligature": "format_align_center",
            "codepoint": "E234"
        }, {
            "iconId": "format_align_justify",
            "name": "format align justify",
            "groupId": "editor",
            "ligature": "format_align_justify",
            "codepoint": "E235"
        }, {
            "iconId": "format_align_left",
            "name": "format align left",
            "groupId": "editor",
            "ligature": "format_align_left",
            "codepoint": "E236"
        }, {
            "iconId": "format_align_right",
            "name": "format align right",
            "groupId": "editor",
            "ligature": "format_align_right",
            "codepoint": "E237"
        }, {
            "iconId": "format_bold",
            "name": "format bold",
            "groupId": "editor",
            "ligature": "format_bold",
            "codepoint": "E238"
        }, {
            "iconId": "format_clear",
            "name": "format clear",
            "groupId": "editor",
            "ligature": "format_clear",
            "codepoint": "E239"
        }, {
            "iconId": "format_color_fill",
            "name": "format color fill",
            "groupId": "editor",
            "ligature": "format_color_fill",
            "codepoint": "E23A"
        }, {
            "iconId": "format_color_reset",
            "name": "format color reset",
            "groupId": "editor",
            "ligature": "format_color_reset",
            "codepoint": "E23B"
        }, {
            "iconId": "format_color_text",
            "name": "format color text",
            "groupId": "editor",
            "ligature": "format_color_text",
            "codepoint": "E23C"
        }, {
            "iconId": "format_indent_decrease",
            "name": "format indent decrease",
            "groupId": "editor",
            "ligature": "format_indent_decrease",
            "codepoint": "E23D"
        }, {
            "iconId": "format_indent_increase",
            "name": "format indent increase",
            "groupId": "editor",
            "ligature": "format_indent_increase",
            "codepoint": "E23E"
        }, {
            "iconId": "format_italic",
            "name": "format italic",
            "groupId": "editor",
            "ligature": "format_italic",
            "codepoint": "E23F"
        }, {
            "iconId": "format_line_spacing",
            "name": "format line spacing",
            "groupId": "editor",
            "ligature": "format_line_spacing",
            "codepoint": "E240"
        }, {
            "iconId": "format_list_bulleted",
            "name": "format list bulleted",
            "groupId": "editor",
            "ligature": "format_list_bulleted",
            "codepoint": "E241"
        }, {
            "iconId": "format_list_numbered",
            "name": "format list numbered",
            "groupId": "editor",
            "ligature": "format_list_numbered",
            "codepoint": "E242"
        }, {
            "iconId": "format_paint",
            "name": "format paint",
            "groupId": "editor",
            "ligature": "format_paint",
            "codepoint": "E243"
        }, {
            "iconId": "format_quote",
            "name": "format quote",
            "groupId": "editor",
            "ligature": "format_quote",
            "codepoint": "E244"
        }, {
            "iconId": "format_shapes",
            "name": "format shapes",
            "groupId": "editor",
            "ligature": "format_shapes",
            "codepoint": "E25E"
        }, {
            "iconId": "format_size",
            "name": "format size",
            "groupId": "editor",
            "ligature": "format_size",
            "codepoint": "E245"
        }, {
            "iconId": "format_strikethrough",
            "name": "format strikethrough",
            "groupId": "editor",
            "ligature": "format_strikethrough",
            "codepoint": "E246"
        }, {
            "iconId": "format_textdirection_l_to_r",
            "name": "format textdirection l to r",
            "groupId": "editor",
            "ligature": "format_textdirection_l_to_r",
            "codepoint": "E247"
        }, {
            "iconId": "format_textdirection_r_to_l",
            "name": "format textdirection r to l",
            "groupId": "editor",
            "ligature": "format_textdirection_r_to_l",
            "codepoint": "E248"
        }, {
            "iconId": "format_underlined",
            "name": "format underlined",
            "groupId": "editor",
            "ligature": "format_underlined",
            "codepoint": "E249"
        }, {
            "iconId": "functions",
            "name": "functions",
            "groupId": "editor",
            "ligature": "functions",
            "codepoint": "E24A"
        }, {
            "iconId": "highlight",
            "name": "highlight",
            "groupId": "editor",
            "ligature": "highlight",
            "codepoint": "E25F"
        }, {
            "iconId": "insert_chart",
            "name": "insert chart",
            "groupId": "editor",
            "ligature": "insert_chart",
            "codepoint": "E24B"
        }, {
            "iconId": "insert_comment",
            "name": "insert comment",
            "groupId": "editor",
            "ligature": "insert_comment",
            "codepoint": "E24C"
        }, {
            "iconId": "insert_drive_file",
            "name": "insert drive file",
            "groupId": "editor",
            "ligature": "insert_drive_file",
            "codepoint": "E24D"
        }, {
            "iconId": "insert_emoticon",
            "name": "insert emoticon",
            "groupId": "editor",
            "ligature": "insert_emoticon",
            "codepoint": "E24E"
        }, {
            "iconId": "insert_invitation",
            "name": "insert invitation",
            "groupId": "editor",
            "ligature": "insert_invitation",
            "codepoint": "E24F"
        }, {
            "iconId": "insert_link",
            "name": "insert link",
            "groupId": "editor",
            "ligature": "insert_link",
            "codepoint": "E250"
        }, {
            "iconId": "insert_photo",
            "name": "insert photo",
            "groupId": "editor",
            "ligature": "insert_photo",
            "codepoint": "E251"
        }, {
            "iconId": "linear_scale",
            "name": "linear scale",
            "groupId": "editor",
            "ligature": "linear_scale",
            "codepoint": "E260"
        }, {
            "iconId": "merge_type",
            "name": "merge type",
            "groupId": "editor",
            "ligature": "merge_type",
            "codepoint": "E252"
        }, {
            "iconId": "mode_comment",
            "name": "mode comment",
            "groupId": "editor",
            "ligature": "mode_comment",
            "codepoint": "E253"
        }, {
            "iconId": "mode_edit",
            "name": "mode edit",
            "groupId": "editor",
            "ligature": "mode_edit",
            "codepoint": "E254"
        }, {
            "iconId": "monetization_on",
            "name": "monetization on",
            "groupId": "editor",
            "ligature": "monetization_on",
            "codepoint": "E263"
        }, {
            "iconId": "money_off",
            "name": "money off",
            "groupId": "editor",
            "ligature": "money_off",
            "codepoint": "E25C"
        }, {
            "iconId": "multiline_chart",
            "name": "multiline chart",
            "groupId": "editor",
            "ligature": "multiline_chart",
            "codepoint": "E6DF"
        }, {
            "iconId": "pie_chart",
            "name": "pie chart",
            "groupId": "editor",
            "ligature": "pie_chart",
            "codepoint": "E6C4"
        }, {
            "iconId": "pie_chart_outlined",
            "name": "pie chart outlined",
            "groupId": "editor",
            "ligature": "pie_chart_outlined",
            "codepoint": "E6C5"
        }, {
            "iconId": "publish",
            "name": "publish",
            "groupId": "editor",
            "ligature": "publish",
            "codepoint": "E255"
        }, {
            "iconId": "short_text",
            "name": "short text",
            "groupId": "editor",
            "ligature": "short_text",
            "codepoint": "E261"
        }, {
            "iconId": "show_chart",
            "name": "show chart",
            "groupId": "editor",
            "ligature": "show_chart",
            "codepoint": "E6E1"
        }, {
            "iconId": "space_bar",
            "name": "space bar",
            "groupId": "editor",
            "ligature": "space_bar",
            "codepoint": "E256"
        }, {
            "iconId": "strikethrough_s",
            "name": "strikethrough s",
            "groupId": "editor",
            "ligature": "strikethrough_s",
            "codepoint": "E257"
        }, {
            "iconId": "text_fields",
            "name": "text fields",
            "groupId": "editor",
            "ligature": "text_fields",
            "codepoint": "E262"
        }, {
            "iconId": "title",
            "name": "title",
            "groupId": "editor",
            "ligature": "title",
            "codepoint": "E264"
        }, {
            "iconId": "vertical_align_bottom",
            "name": "vertical align bottom",
            "groupId": "editor",
            "ligature": "vertical_align_bottom",
            "codepoint": "E258"
        }, {
            "iconId": "vertical_align_center",
            "name": "vertical align center",
            "groupId": "editor",
            "ligature": "vertical_align_center",
            "codepoint": "E259"
        }, {
            "iconId": "vertical_align_top",
            "name": "vertical align top",
            "groupId": "editor",
            "ligature": "vertical_align_top",
            "codepoint": "E25A"
        }, {
            "iconId": "wrap_text",
            "name": "wrap text",
            "groupId": "editor",
            "ligature": "wrap_text",
            "codepoint": "E25B"
        }, {
            "iconId": "attachment",
            "name": "attachment",
            "groupId": "file",
            "ligature": "attachment",
            "codepoint": "E2BC"
        }, {
            "iconId": "cloud",
            "name": "cloud",
            "groupId": "file",
            "ligature": "cloud",
            "codepoint": "E2BD"
        }, {
            "iconId": "cloud_circle",
            "name": "cloud circle",
            "groupId": "file",
            "ligature": "cloud_circle",
            "codepoint": "E2BE"
        }, {
            "iconId": "cloud_done",
            "name": "cloud done",
            "groupId": "file",
            "ligature": "cloud_done",
            "codepoint": "E2BF"
        }, {
            "iconId": "cloud_download",
            "name": "cloud download",
            "groupId": "file",
            "ligature": "cloud_download",
            "codepoint": "E2C0"
        }, {
            "iconId": "cloud_off",
            "name": "cloud off",
            "groupId": "file",
            "ligature": "cloud_off",
            "codepoint": "E2C1"
        }, {
            "iconId": "cloud_queue",
            "name": "cloud queue",
            "groupId": "file",
            "ligature": "cloud_queue",
            "codepoint": "E2C2"
        }, {
            "iconId": "cloud_upload",
            "name": "cloud upload",
            "groupId": "file",
            "ligature": "cloud_upload",
            "codepoint": "E2C3"
        }, {
            "iconId": "create_new_folder",
            "name": "create new folder",
            "groupId": "file",
            "ligature": "create_new_folder",
            "codepoint": "E2CC"
        }, {
            "iconId": "file_download",
            "name": "file download",
            "groupId": "file",
            "ligature": "file_download",
            "codepoint": "E2C4"
        }, {
            "iconId": "file_upload",
            "name": "file upload",
            "groupId": "file",
            "ligature": "file_upload",
            "codepoint": "E2C6"
        }, {
            "iconId": "folder",
            "name": "folder",
            "groupId": "file",
            "ligature": "folder",
            "codepoint": "E2C7"
        }, {
            "iconId": "folder_open",
            "name": "folder open",
            "groupId": "file",
            "ligature": "folder_open",
            "codepoint": "E2C8"
        }, {
            "iconId": "folder_shared",
            "name": "folder shared",
            "groupId": "file",
            "ligature": "folder_shared",
            "codepoint": "E2C9"
        }, {
            "iconId": "cast",
            "name": "cast",
            "groupId": "hardware",
            "ligature": "cast",
            "codepoint": "E307"
        }, {
            "iconId": "cast_connected",
            "name": "cast connected",
            "groupId": "hardware",
            "ligature": "cast_connected",
            "codepoint": "E308"
        }, {
            "iconId": "computer",
            "name": "computer",
            "groupId": "hardware",
            "ligature": "computer",
            "codepoint": "E30A"
        }, {
            "iconId": "desktop_mac",
            "name": "desktop mac",
            "groupId": "hardware",
            "ligature": "desktop_mac",
            "codepoint": "E30B"
        }, {
            "iconId": "desktop_windows",
            "name": "desktop windows",
            "groupId": "hardware",
            "ligature": "desktop_windows",
            "codepoint": "E30C"
        }, {
            "iconId": "developer_board",
            "name": "developer board",
            "groupId": "hardware",
            "ligature": "developer_board",
            "codepoint": "E30D"
        }, {
            "iconId": "device_hub",
            "name": "device hub",
            "groupId": "hardware",
            "ligature": "device_hub",
            "codepoint": "E335"
        }, {
            "iconId": "devices_other",
            "name": "devices other",
            "groupId": "hardware",
            "ligature": "devices_other",
            "codepoint": "E337"
        }, {
            "iconId": "dock",
            "name": "dock",
            "groupId": "hardware",
            "ligature": "dock",
            "codepoint": "E30E"
        }, {
            "iconId": "gamepad",
            "name": "gamepad",
            "groupId": "hardware",
            "ligature": "gamepad",
            "codepoint": "E30F"
        }, {
            "iconId": "headset",
            "name": "headset",
            "groupId": "hardware",
            "ligature": "headset",
            "codepoint": "E310"
        }, {
            "iconId": "headset_mic",
            "name": "headset mic",
            "groupId": "hardware",
            "ligature": "headset_mic",
            "codepoint": "E311"
        }, {
            "iconId": "keyboard",
            "name": "keyboard",
            "groupId": "hardware",
            "ligature": "keyboard",
            "codepoint": "E312"
        }, {
            "iconId": "keyboard_arrow_down",
            "name": "keyboard arrow down",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_down",
            "codepoint": "E313"
        }, {
            "iconId": "keyboard_arrow_left",
            "name": "keyboard arrow left",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_left",
            "codepoint": "E314"
        }, {
            "iconId": "keyboard_arrow_right",
            "name": "keyboard arrow right",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_right",
            "codepoint": "E315"
        }, {
            "iconId": "keyboard_arrow_up",
            "name": "keyboard arrow up",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_up",
            "codepoint": "E316"
        }, {
            "iconId": "keyboard_backspace",
            "name": "keyboard backspace",
            "groupId": "hardware",
            "ligature": "keyboard_backspace",
            "codepoint": "E317"
        }, {
            "iconId": "keyboard_capslock",
            "name": "keyboard capslock",
            "groupId": "hardware",
            "ligature": "keyboard_capslock",
            "codepoint": "E318"
        }, {
            "iconId": "keyboard_hide",
            "name": "keyboard hide",
            "groupId": "hardware",
            "ligature": "keyboard_hide",
            "codepoint": "E31A"
        }, {
            "iconId": "keyboard_return",
            "name": "keyboard return",
            "groupId": "hardware",
            "ligature": "keyboard_return",
            "codepoint": "E31B"
        }, {
            "iconId": "keyboard_tab",
            "name": "keyboard tab",
            "groupId": "hardware",
            "ligature": "keyboard_tab",
            "codepoint": "E31C"
        }, {
            "iconId": "keyboard_voice",
            "name": "keyboard voice",
            "groupId": "hardware",
            "ligature": "keyboard_voice",
            "codepoint": "E31D"
        }, {
            "iconId": "laptop",
            "name": "laptop",
            "groupId": "hardware",
            "ligature": "laptop",
            "codepoint": "E31E"
        }, {
            "iconId": "laptop_chromebook",
            "name": "laptop chromebook",
            "groupId": "hardware",
            "ligature": "laptop_chromebook",
            "codepoint": "E31F"
        }, {
            "iconId": "laptop_mac",
            "name": "laptop mac",
            "groupId": "hardware",
            "ligature": "laptop_mac",
            "codepoint": "E320"
        }, {
            "iconId": "laptop_windows",
            "name": "laptop windows",
            "groupId": "hardware",
            "ligature": "laptop_windows",
            "codepoint": "E321"
        }, {
            "iconId": "memory",
            "name": "memory",
            "groupId": "hardware",
            "ligature": "memory",
            "codepoint": "E322"
        }, {
            "iconId": "mouse",
            "name": "mouse",
            "groupId": "hardware",
            "ligature": "mouse",
            "codepoint": "E323"
        }, {
            "iconId": "phone_android",
            "name": "phone android",
            "groupId": "hardware",
            "ligature": "phone_android",
            "codepoint": "E324"
        }, {
            "iconId": "phone_iphone",
            "name": "phone iphone",
            "groupId": "hardware",
            "ligature": "phone_iphone",
            "codepoint": "E325"
        }, {
            "iconId": "phonelink",
            "name": "phonelink",
            "groupId": "hardware",
            "ligature": "phonelink",
            "codepoint": "E326"
        }, {
            "iconId": "phonelink_off",
            "name": "phonelink off",
            "groupId": "hardware",
            "ligature": "phonelink_off",
            "codepoint": "E327"
        }, {
            "iconId": "power_input",
            "name": "power input",
            "groupId": "hardware",
            "ligature": "power_input",
            "codepoint": "E336"
        }, {
            "iconId": "router",
            "name": "router",
            "groupId": "hardware",
            "ligature": "router",
            "codepoint": "E328"
        }, {
            "iconId": "scanner",
            "name": "scanner",
            "groupId": "hardware",
            "ligature": "scanner",
            "codepoint": "E329"
        }, {
            "iconId": "security",
            "name": "security",
            "groupId": "hardware",
            "ligature": "security",
            "codepoint": "E32A"
        }, {
            "iconId": "sim_card",
            "name": "sim card",
            "groupId": "hardware",
            "ligature": "sim_card",
            "codepoint": "E32B"
        }, {
            "iconId": "smartphone",
            "name": "smartphone",
            "groupId": "hardware",
            "ligature": "smartphone",
            "codepoint": "E32C"
        }, {
            "iconId": "speaker",
            "name": "speaker",
            "groupId": "hardware",
            "ligature": "speaker",
            "codepoint": "E32D"
        }, {
            "iconId": "speaker_group",
            "name": "speaker group",
            "groupId": "hardware",
            "ligature": "speaker_group",
            "codepoint": "E32E"
        }, {
            "iconId": "tablet",
            "name": "tablet",
            "groupId": "hardware",
            "ligature": "tablet",
            "codepoint": "E32F"
        }, {
            "iconId": "tablet_android",
            "name": "tablet android",
            "groupId": "hardware",
            "ligature": "tablet_android",
            "codepoint": "E330"
        }, {
            "iconId": "tablet_mac",
            "name": "tablet mac",
            "groupId": "hardware",
            "ligature": "tablet_mac",
            "codepoint": "E331"
        }, {
            "iconId": "toys",
            "name": "toys",
            "groupId": "hardware",
            "ligature": "toys",
            "codepoint": "E332"
        }, {
            "iconId": "tv",
            "name": "tv",
            "groupId": "hardware",
            "ligature": "tv",
            "codepoint": "E333"
        }, {
            "iconId": "videogame_asset",
            "name": "videogame asset",
            "groupId": "hardware",
            "ligature": "videogame_asset",
            "codepoint": "E338"
        }, {
            "iconId": "watch",
            "name": "watch",
            "groupId": "hardware",
            "ligature": "watch",
            "codepoint": "E334"
        }, {
            "iconId": "add_a_photo",
            "name": "add a photo",
            "groupId": "image",
            "ligature": "add_a_photo",
            "codepoint": "E439"
        }, {
            "iconId": "add_to_photos",
            "name": "add to photos",
            "groupId": "image",
            "ligature": "add_to_photos",
            "codepoint": "E39D"
        }, {
            "iconId": "adjust",
            "name": "adjust",
            "groupId": "image",
            "ligature": "adjust",
            "codepoint": "E39E"
        }, {
            "iconId": "assistant",
            "name": "assistant",
            "groupId": "image",
            "ligature": "assistant",
            "codepoint": "E39F"
        }, {
            "iconId": "assistant_photo",
            "name": "assistant photo",
            "groupId": "image",
            "ligature": "assistant_photo",
            "codepoint": "E3A0"
        }, {
            "iconId": "audiotrack",
            "name": "audiotrack",
            "groupId": "image",
            "ligature": "audiotrack",
            "codepoint": "E3A1"
        }, {
            "iconId": "blur_circular",
            "name": "blur circular",
            "groupId": "image",
            "ligature": "blur_circular",
            "codepoint": "E3A2"
        }, {
            "iconId": "blur_linear",
            "name": "blur linear",
            "groupId": "image",
            "ligature": "blur_linear",
            "codepoint": "E3A3"
        }, {
            "iconId": "blur_off",
            "name": "blur off",
            "groupId": "image",
            "ligature": "blur_off",
            "codepoint": "E3A4"
        }, {
            "iconId": "blur_on",
            "name": "blur on",
            "groupId": "image",
            "ligature": "blur_on",
            "codepoint": "E3A5"
        }, {
            "iconId": "brightness_1",
            "name": "brightness 1",
            "groupId": "image",
            "ligature": "brightness_1",
            "codepoint": "E3A6"
        }, {
            "iconId": "brightness_2",
            "name": "brightness 2",
            "groupId": "image",
            "ligature": "brightness_2",
            "codepoint": "E3A7"
        }, {
            "iconId": "brightness_3",
            "name": "brightness 3",
            "groupId": "image",
            "ligature": "brightness_3",
            "codepoint": "E3A8"
        }, {
            "iconId": "brightness_4",
            "name": "brightness 4",
            "groupId": "image",
            "ligature": "brightness_4",
            "codepoint": "E3A9"
        }, {
            "iconId": "brightness_5",
            "name": "brightness 5",
            "groupId": "image",
            "ligature": "brightness_5",
            "codepoint": "E3AA"
        }, {
            "iconId": "brightness_6",
            "name": "brightness 6",
            "groupId": "image",
            "ligature": "brightness_6",
            "codepoint": "E3AB"
        }, {
            "iconId": "brightness_7",
            "name": "brightness 7",
            "groupId": "image",
            "ligature": "brightness_7",
            "codepoint": "E3AC"
        }, {
            "iconId": "broken_image",
            "name": "broken image",
            "groupId": "image",
            "ligature": "broken_image",
            "codepoint": "E3AD"
        }, {
            "iconId": "brush",
            "name": "brush",
            "groupId": "image",
            "ligature": "brush",
            "codepoint": "E3AE"
        }, {
            "iconId": "burst_mode",
            "name": "burst mode",
            "groupId": "image",
            "ligature": "burst_mode",
            "codepoint": "E43C"
        }, {
            "iconId": "camera",
            "name": "camera",
            "groupId": "image",
            "ligature": "camera",
            "codepoint": "E3AF"
        }, {
            "iconId": "camera_alt",
            "name": "camera alt",
            "groupId": "image",
            "ligature": "camera_alt",
            "codepoint": "E3B0"
        }, {
            "iconId": "camera_front",
            "name": "camera front",
            "groupId": "image",
            "ligature": "camera_front",
            "codepoint": "E3B1"
        }, {
            "iconId": "camera_rear",
            "name": "camera rear",
            "groupId": "image",
            "ligature": "camera_rear",
            "codepoint": "E3B2"
        }, {
            "iconId": "camera_roll",
            "name": "camera roll",
            "groupId": "image",
            "ligature": "camera_roll",
            "codepoint": "E3B3"
        }, {
            "iconId": "center_focus_strong",
            "name": "center focus strong",
            "groupId": "image",
            "ligature": "center_focus_strong",
            "codepoint": "E3B4"
        }, {
            "iconId": "center_focus_weak",
            "name": "center focus weak",
            "groupId": "image",
            "ligature": "center_focus_weak",
            "codepoint": "E3B5"
        }, {
            "iconId": "collections",
            "name": "collections",
            "groupId": "image",
            "ligature": "collections",
            "codepoint": "E3B6"
        }, {
            "iconId": "collections_bookmark",
            "name": "collections bookmark",
            "groupId": "image",
            "ligature": "collections_bookmark",
            "codepoint": "E431"
        }, {
            "iconId": "color_lens",
            "name": "color lens",
            "groupId": "image",
            "ligature": "color_lens",
            "codepoint": "E3B7"
        }, {
            "iconId": "colorize",
            "name": "colorize",
            "groupId": "image",
            "ligature": "colorize",
            "codepoint": "E3B8"
        }, {
            "iconId": "compare",
            "name": "compare",
            "groupId": "image",
            "ligature": "compare",
            "codepoint": "E3B9"
        }, {
            "iconId": "control_point",
            "name": "control point",
            "groupId": "image",
            "ligature": "control_point",
            "codepoint": "E3BA"
        }, {
            "iconId": "control_point_duplicate",
            "name": "control point duplicate",
            "groupId": "image",
            "ligature": "control_point_duplicate",
            "codepoint": "E3BB"
        }, {
            "iconId": "crop",
            "name": "crop",
            "groupId": "image",
            "ligature": "crop",
            "codepoint": "E3BE"
        }, {
            "iconId": "crop_16_9",
            "name": "crop 16 9",
            "groupId": "image",
            "ligature": "crop_16_9",
            "codepoint": "E3BC"
        }, {
            "iconId": "crop_3_2",
            "name": "crop 3 2",
            "groupId": "image",
            "ligature": "crop_3_2",
            "codepoint": "E3BD"
        }, {
            "iconId": "crop_5_4",
            "name": "crop 5 4",
            "groupId": "image",
            "ligature": "crop_5_4",
            "codepoint": "E3BF"
        }, {
            "iconId": "crop_7_5",
            "name": "crop 7 5",
            "groupId": "image",
            "ligature": "crop_7_5",
            "codepoint": "E3C0"
        }, {
            "iconId": "crop_din",
            "name": "crop din",
            "groupId": "image",
            "ligature": "crop_din",
            "codepoint": "E3C1"
        }, {
            "iconId": "crop_free",
            "name": "crop free",
            "groupId": "image",
            "ligature": "crop_free",
            "codepoint": "E3C2"
        }, {
            "iconId": "crop_landscape",
            "name": "crop landscape",
            "groupId": "image",
            "ligature": "crop_landscape",
            "codepoint": "E3C3"
        }, {
            "iconId": "crop_original",
            "name": "crop original",
            "groupId": "image",
            "ligature": "crop_original",
            "codepoint": "E3C4"
        }, {
            "iconId": "crop_portrait",
            "name": "crop portrait",
            "groupId": "image",
            "ligature": "crop_portrait",
            "codepoint": "E3C5"
        }, {
            "iconId": "crop_rotate",
            "name": "crop rotate",
            "groupId": "image",
            "ligature": "crop_rotate",
            "codepoint": "E437"
        }, {
            "iconId": "crop_square",
            "name": "crop square",
            "groupId": "image",
            "ligature": "crop_square",
            "codepoint": "E3C6"
        }, {
            "iconId": "dehaze",
            "name": "dehaze",
            "groupId": "image",
            "ligature": "dehaze",
            "codepoint": "E3C7"
        }, {
            "iconId": "details",
            "name": "details",
            "groupId": "image",
            "ligature": "details",
            "codepoint": "E3C8"
        }, {
            "iconId": "edit",
            "name": "edit",
            "groupId": "image",
            "ligature": "edit",
            "codepoint": "E3C9"
        }, {
            "iconId": "exposure",
            "name": "exposure",
            "groupId": "image",
            "ligature": "exposure",
            "codepoint": "E3CA"
        }, {
            "iconId": "exposure_neg_1",
            "name": "exposure neg 1",
            "groupId": "image",
            "ligature": "exposure_neg_1",
            "codepoint": "E3CB"
        }, {
            "iconId": "exposure_neg_2",
            "name": "exposure neg 2",
            "groupId": "image",
            "ligature": "exposure_neg_2",
            "codepoint": "E3CC"
        }, {
            "iconId": "exposure_plus_1",
            "name": "exposure plus 1",
            "groupId": "image",
            "ligature": "exposure_plus_1",
            "codepoint": "E3CD"
        }, {
            "iconId": "exposure_plus_2",
            "name": "exposure plus 2",
            "groupId": "image",
            "ligature": "exposure_plus_2",
            "codepoint": "E3CE"
        }, {
            "iconId": "exposure_zero",
            "name": "exposure zero",
            "groupId": "image",
            "ligature": "exposure_zero",
            "codepoint": "E3CF"
        }, {
            "iconId": "filter",
            "name": "filter",
            "groupId": "image",
            "ligature": "filter",
            "codepoint": "E3D3"
        }, {
            "iconId": "filter_1",
            "name": "filter 1",
            "groupId": "image",
            "ligature": "filter_1",
            "codepoint": "E3D0"
        }, {
            "iconId": "filter_2",
            "name": "filter 2",
            "groupId": "image",
            "ligature": "filter_2",
            "codepoint": "E3D1"
        }, {
            "iconId": "filter_3",
            "name": "filter 3",
            "groupId": "image",
            "ligature": "filter_3",
            "codepoint": "E3D2"
        }, {
            "iconId": "filter_4",
            "name": "filter 4",
            "groupId": "image",
            "ligature": "filter_4",
            "codepoint": "E3D4"
        }, {
            "iconId": "filter_5",
            "name": "filter 5",
            "groupId": "image",
            "ligature": "filter_5",
            "codepoint": "E3D5"
        }, {
            "iconId": "filter_6",
            "name": "filter 6",
            "groupId": "image",
            "ligature": "filter_6",
            "codepoint": "E3D6"
        }, {
            "iconId": "filter_7",
            "name": "filter 7",
            "groupId": "image",
            "ligature": "filter_7",
            "codepoint": "E3D7"
        }, {
            "iconId": "filter_8",
            "name": "filter 8",
            "groupId": "image",
            "ligature": "filter_8",
            "codepoint": "E3D8"
        }, {
            "iconId": "filter_9",
            "name": "filter 9",
            "groupId": "image",
            "ligature": "filter_9",
            "codepoint": "E3D9"
        }, {
            "iconId": "filter_9_plus",
            "name": "filter 9 plus",
            "groupId": "image",
            "ligature": "filter_9_plus",
            "codepoint": "E3DA"
        }, {
            "iconId": "filter_b_and_w",
            "name": "filter b and w",
            "groupId": "image",
            "ligature": "filter_b_and_w",
            "codepoint": "E3DB"
        }, {
            "iconId": "filter_center_focus",
            "name": "filter center focus",
            "groupId": "image",
            "ligature": "filter_center_focus",
            "codepoint": "E3DC"
        }, {
            "iconId": "filter_drama",
            "name": "filter drama",
            "groupId": "image",
            "ligature": "filter_drama",
            "codepoint": "E3DD"
        }, {
            "iconId": "filter_frames",
            "name": "filter frames",
            "groupId": "image",
            "ligature": "filter_frames",
            "codepoint": "E3DE"
        }, {
            "iconId": "filter_hdr",
            "name": "filter hdr",
            "groupId": "image",
            "ligature": "filter_hdr",
            "codepoint": "E3DF"
        }, {
            "iconId": "filter_none",
            "name": "filter none",
            "groupId": "image",
            "ligature": "filter_none",
            "codepoint": "E3E0"
        }, {
            "iconId": "filter_tilt_shift",
            "name": "filter tilt shift",
            "groupId": "image",
            "ligature": "filter_tilt_shift",
            "codepoint": "E3E2"
        }, {
            "iconId": "filter_vintage",
            "name": "filter vintage",
            "groupId": "image",
            "ligature": "filter_vintage",
            "codepoint": "E3E3"
        }, {
            "iconId": "flare",
            "name": "flare",
            "groupId": "image",
            "ligature": "flare",
            "codepoint": "E3E4"
        }, {
            "iconId": "flash_auto",
            "name": "flash auto",
            "groupId": "image",
            "ligature": "flash_auto",
            "codepoint": "E3E5"
        }, {
            "iconId": "flash_off",
            "name": "flash off",
            "groupId": "image",
            "ligature": "flash_off",
            "codepoint": "E3E6"
        }, {
            "iconId": "flash_on",
            "name": "flash on",
            "groupId": "image",
            "ligature": "flash_on",
            "codepoint": "E3E7"
        }, {
            "iconId": "flip",
            "name": "flip",
            "groupId": "image",
            "ligature": "flip",
            "codepoint": "E3E8"
        }, {
            "iconId": "gradient",
            "name": "gradient",
            "groupId": "image",
            "ligature": "gradient",
            "codepoint": "E3E9"
        }, {
            "iconId": "grain",
            "name": "grain",
            "groupId": "image",
            "ligature": "grain",
            "codepoint": "E3EA"
        }, {
            "iconId": "grid_off",
            "name": "grid off",
            "groupId": "image",
            "ligature": "grid_off",
            "codepoint": "E3EB"
        }, {
            "iconId": "grid_on",
            "name": "grid on",
            "groupId": "image",
            "ligature": "grid_on",
            "codepoint": "E3EC"
        }, {
            "iconId": "hdr_off",
            "name": "hdr off",
            "groupId": "image",
            "ligature": "hdr_off",
            "codepoint": "E3ED"
        }, {
            "iconId": "hdr_on",
            "name": "hdr on",
            "groupId": "image",
            "ligature": "hdr_on",
            "codepoint": "E3EE"
        }, {
            "iconId": "hdr_strong",
            "name": "hdr strong",
            "groupId": "image",
            "ligature": "hdr_strong",
            "codepoint": "E3F1"
        }, {
            "iconId": "hdr_weak",
            "name": "hdr weak",
            "groupId": "image",
            "ligature": "hdr_weak",
            "codepoint": "E3F2"
        }, {
            "iconId": "healing",
            "name": "healing",
            "groupId": "image",
            "ligature": "healing",
            "codepoint": "E3F3"
        }, {
            "iconId": "image",
            "name": "image",
            "groupId": "image",
            "ligature": "image",
            "codepoint": "E3F4"
        }, {
            "iconId": "image_aspect_ratio",
            "name": "image aspect ratio",
            "groupId": "image",
            "ligature": "image_aspect_ratio",
            "codepoint": "E3F5"
        }, {
            "iconId": "iso",
            "name": "iso",
            "groupId": "image",
            "ligature": "iso",
            "codepoint": "E3F6"
        }, {
            "iconId": "landscape",
            "name": "landscape",
            "groupId": "image",
            "ligature": "landscape",
            "codepoint": "E3F7"
        }, {
            "iconId": "leak_add",
            "name": "leak add",
            "groupId": "image",
            "ligature": "leak_add",
            "codepoint": "E3F8"
        }, {
            "iconId": "leak_remove",
            "name": "leak remove",
            "groupId": "image",
            "ligature": "leak_remove",
            "codepoint": "E3F9"
        }, {
            "iconId": "lens",
            "name": "lens",
            "groupId": "image",
            "ligature": "lens",
            "codepoint": "E3FA"
        }, {
            "iconId": "linked_camera",
            "name": "linked camera",
            "groupId": "image",
            "ligature": "linked_camera",
            "codepoint": "E438"
        }, {
            "iconId": "looks",
            "name": "looks",
            "groupId": "image",
            "ligature": "looks",
            "codepoint": "E3FC"
        }, {
            "iconId": "looks_3",
            "name": "looks 3",
            "groupId": "image",
            "ligature": "looks_3",
            "codepoint": "E3FB"
        }, {
            "iconId": "looks_4",
            "name": "looks 4",
            "groupId": "image",
            "ligature": "looks_4",
            "codepoint": "E3FD"
        }, {
            "iconId": "looks_5",
            "name": "looks 5",
            "groupId": "image",
            "ligature": "looks_5",
            "codepoint": "E3FE"
        }, {
            "iconId": "looks_6",
            "name": "looks 6",
            "groupId": "image",
            "ligature": "looks_6",
            "codepoint": "E3FF"
        }, {
            "iconId": "looks_one",
            "name": "looks one",
            "groupId": "image",
            "ligature": "looks_one",
            "codepoint": "E400"
        }, {
            "iconId": "looks_two",
            "name": "looks two",
            "groupId": "image",
            "ligature": "looks_two",
            "codepoint": "E401"
        }, {
            "iconId": "loupe",
            "name": "loupe",
            "groupId": "image",
            "ligature": "loupe",
            "codepoint": "E402"
        }, {
            "iconId": "monochrome_photos",
            "name": "monochrome photos",
            "groupId": "image",
            "ligature": "monochrome_photos",
            "codepoint": "E403"
        }, {
            "iconId": "movie_creation",
            "name": "movie creation",
            "groupId": "image",
            "ligature": "movie_creation",
            "codepoint": "E404"
        }, {
            "iconId": "movie_filter",
            "name": "movie filter",
            "groupId": "image",
            "ligature": "movie_filter",
            "codepoint": "E43A"
        }, {
            "iconId": "musnote",
            "name": "music note",
            "groupId": "image",
            "ligature": "musnote",
            "codepoint": "E405"
        }, {
            "iconId": "nature",
            "name": "nature",
            "groupId": "image",
            "ligature": "nature",
            "codepoint": "E406"
        }, {
            "iconId": "nature_people",
            "name": "nature people",
            "groupId": "image",
            "ligature": "nature_people",
            "codepoint": "E407"
        }, {
            "iconId": "navigate_before",
            "name": "navigate before",
            "groupId": "image",
            "ligature": "navigate_before",
            "codepoint": "E408"
        }, {
            "iconId": "navigate_next",
            "name": "navigate next",
            "groupId": "image",
            "ligature": "navigate_next",
            "codepoint": "E409"
        }, {
            "iconId": "palette",
            "name": "palette",
            "groupId": "image",
            "ligature": "palette",
            "codepoint": "E40A"
        }, {
            "iconId": "panorama",
            "name": "panorama",
            "groupId": "image",
            "ligature": "panorama",
            "codepoint": "E40B"
        }, {
            "iconId": "panorama_fish_eye",
            "name": "panorama fish eye",
            "groupId": "image",
            "ligature": "panorama_fish_eye",
            "codepoint": "E40C"
        }, {
            "iconId": "panorama_horizontal",
            "name": "panorama horizontal",
            "groupId": "image",
            "ligature": "panorama_horizontal",
            "codepoint": "E40D"
        }, {
            "iconId": "panorama_vertical",
            "name": "panorama vertical",
            "groupId": "image",
            "ligature": "panorama_vertical",
            "codepoint": "E40E"
        }, {
            "iconId": "panorama_wide_angle",
            "name": "panorama wide angle",
            "groupId": "image",
            "ligature": "panorama_wide_angle",
            "codepoint": "E40F"
        }, {
            "iconId": "photo",
            "name": "photo",
            "groupId": "image",
            "ligature": "photo",
            "codepoint": "E410"
        }, {
            "iconId": "photo_album",
            "name": "photo album",
            "groupId": "image",
            "ligature": "photo_album",
            "codepoint": "E411"
        }, {
            "iconId": "photo_camera",
            "name": "photo camera",
            "groupId": "image",
            "ligature": "photo_camera",
            "codepoint": "E412"
        }, {
            "iconId": "photo_filter",
            "name": "photo filter",
            "groupId": "image",
            "ligature": "photo_filter",
            "codepoint": "E43B"
        }, {
            "iconId": "photo_library",
            "name": "photo library",
            "groupId": "image",
            "ligature": "photo_library",
            "codepoint": "E413"
        }, {
            "iconId": "photo_size_select_actual",
            "name": "photo size select actual",
            "groupId": "image",
            "ligature": "photo_size_select_actual",
            "codepoint": "E432"
        }, {
            "iconId": "photo_size_select_large",
            "name": "photo size select large",
            "groupId": "image",
            "ligature": "photo_size_select_large",
            "codepoint": "E433"
        }, {
            "iconId": "photo_size_select_small",
            "name": "photo size select small",
            "groupId": "image",
            "ligature": "photo_size_select_small",
            "codepoint": "E434"
        }, {
            "iconId": "picture_as_pdf",
            "name": "picture as pdf",
            "groupId": "image",
            "ligature": "picture_as_pdf",
            "codepoint": "E415"
        }, {
            "iconId": "portrait",
            "name": "portrait",
            "groupId": "image",
            "ligature": "portrait",
            "codepoint": "E416"
        }, {
            "iconId": "remove_red_eye",
            "name": "remove red eye",
            "groupId": "image",
            "ligature": "remove_red_eye",
            "codepoint": "E417"
        }, {
            "iconId": "rotate_90_degrees_ccw",
            "name": "rotate 90 degrees ccw",
            "groupId": "image",
            "ligature": "rotate_90_degrees_ccw",
            "codepoint": "E418"
        }, {
            "iconId": "rotate_left",
            "name": "rotate left",
            "groupId": "image",
            "ligature": "rotate_left",
            "codepoint": "E419"
        }, {
            "iconId": "rotate_right",
            "name": "rotate right",
            "groupId": "image",
            "ligature": "rotate_right",
            "codepoint": "E41A"
        }, {
            "iconId": "slideshow",
            "name": "slideshow",
            "groupId": "image",
            "ligature": "slideshow",
            "codepoint": "E41B"
        }, {
            "iconId": "straighten",
            "name": "straighten",
            "groupId": "image",
            "ligature": "straighten",
            "codepoint": "E41C"
        }, {
            "iconId": "style",
            "name": "style",
            "groupId": "image",
            "ligature": "style",
            "codepoint": "E41D"
        }, {
            "iconId": "switch_camera",
            "name": "switch camera",
            "groupId": "image",
            "ligature": "switch_camera",
            "codepoint": "E41E"
        }, {
            "iconId": "switch_video",
            "name": "switch video",
            "groupId": "image",
            "ligature": "switch_video",
            "codepoint": "E41F"
        }, {
            "iconId": "tag_faces",
            "name": "tag faces",
            "groupId": "image",
            "ligature": "tag_faces",
            "codepoint": "E420"
        }, {
            "iconId": "texture",
            "name": "texture",
            "groupId": "image",
            "ligature": "texture",
            "codepoint": "E421"
        }, {
            "iconId": "timelapse",
            "name": "timelapse",
            "groupId": "image",
            "ligature": "timelapse",
            "codepoint": "E422"
        }, {
            "iconId": "timer",
            "name": "timer",
            "groupId": "image",
            "ligature": "timer",
            "codepoint": "E425"
        }, {
            "iconId": "timer_10",
            "name": "timer 10",
            "groupId": "image",
            "ligature": "timer_10",
            "codepoint": "E423"
        }, {
            "iconId": "timer_3",
            "name": "timer 3",
            "groupId": "image",
            "ligature": "timer_3",
            "codepoint": "E424"
        }, {
            "iconId": "timer_off",
            "name": "timer off",
            "groupId": "image",
            "ligature": "timer_off",
            "codepoint": "E426"
        }, {
            "iconId": "tonality",
            "name": "tonality",
            "groupId": "image",
            "ligature": "tonality",
            "codepoint": "E427"
        }, {
            "iconId": "transform",
            "name": "transform",
            "groupId": "image",
            "ligature": "transform",
            "codepoint": "E428"
        }, {
            "iconId": "tune",
            "name": "tune",
            "groupId": "image",
            "ligature": "tune",
            "codepoint": "E429"
        }, {
            "iconId": "view_comfy",
            "name": "view comfy",
            "groupId": "image",
            "ligature": "view_comfy",
            "codepoint": "E42A"
        }, {
            "iconId": "view_compact",
            "name": "view compact",
            "groupId": "image",
            "ligature": "view_compact",
            "codepoint": "E42B"
        }, {
            "iconId": "vignette",
            "name": "vignette",
            "groupId": "image",
            "ligature": "vignette",
            "codepoint": "E435"
        }, {
            "iconId": "wb_auto",
            "name": "wb auto",
            "groupId": "image",
            "ligature": "wb_auto",
            "codepoint": "E42C"
        }, {
            "iconId": "wb_cloudy",
            "name": "wb cloudy",
            "groupId": "image",
            "ligature": "wb_cloudy",
            "codepoint": "E42D"
        }, {
            "iconId": "wb_incandescent",
            "name": "wb incandescent",
            "groupId": "image",
            "ligature": "wb_incandescent",
            "codepoint": "E42E"
        }, {
            "iconId": "wb_iridescent",
            "name": "wb iridescent",
            "groupId": "image",
            "ligature": "wb_iridescent",
            "codepoint": "E436"
        }, {
            "iconId": "wb_sunny",
            "name": "wb sunny",
            "groupId": "image",
            "ligature": "wb_sunny",
            "codepoint": "E430"
        }, {
            "iconId": "add_location",
            "name": "add location",
            "groupId": "maps",
            "ligature": "add_location",
            "codepoint": "E567"
        }, {
            "iconId": "beenhere",
            "name": "beenhere",
            "groupId": "maps",
            "ligature": "beenhere",
            "codepoint": "E52D"
        }, {
            "iconId": "directions",
            "name": "directions",
            "groupId": "maps",
            "ligature": "directions",
            "codepoint": "E52E"
        }, {
            "iconId": "directions_bike",
            "name": "directions bike",
            "groupId": "maps",
            "ligature": "directions_bike",
            "codepoint": "E52F"
        }, {
            "iconId": "directions_boat",
            "name": "directions boat",
            "groupId": "maps",
            "ligature": "directions_boat",
            "codepoint": "E532"
        }, {
            "iconId": "directions_bus",
            "name": "directions bus",
            "groupId": "maps",
            "ligature": "directions_bus",
            "codepoint": "E530"
        }, {
            "iconId": "directions_car",
            "name": "directions car",
            "groupId": "maps",
            "ligature": "directions_car",
            "codepoint": "E531"
        }, {
            "iconId": "directions_railway",
            "name": "directions railway",
            "groupId": "maps",
            "ligature": "directions_railway",
            "codepoint": "E534"
        }, {
            "iconId": "directions_run",
            "name": "directions run",
            "groupId": "maps",
            "ligature": "directions_run",
            "codepoint": "E566"
        }, {
            "iconId": "directions_subway",
            "name": "directions subway",
            "groupId": "maps",
            "ligature": "directions_subway",
            "codepoint": "E533"
        }, {
            "iconId": "directions_transit",
            "name": "directions transit",
            "groupId": "maps",
            "ligature": "directions_transit",
            "codepoint": "E535"
        }, {
            "iconId": "directions_walk",
            "name": "directions walk",
            "groupId": "maps",
            "ligature": "directions_walk",
            "codepoint": "E536"
        }, {
            "iconId": "edit_location",
            "name": "edit location",
            "groupId": "maps",
            "ligature": "edit_location",
            "codepoint": "E568"
        }, {
            "iconId": "ev_station",
            "name": "ev station",
            "groupId": "maps",
            "ligature": "ev_station",
            "codepoint": "E56D"
        }, {
            "iconId": "flight",
            "name": "flight",
            "groupId": "maps",
            "ligature": "flight",
            "codepoint": "E539"
        }, {
            "iconId": "hotel",
            "name": "hotel",
            "groupId": "maps",
            "ligature": "hotel",
            "codepoint": "E53A"
        }, {
            "iconId": "layers",
            "name": "layers",
            "groupId": "maps",
            "ligature": "layers",
            "codepoint": "E53B"
        }, {
            "iconId": "layers_clear",
            "name": "layers clear",
            "groupId": "maps",
            "ligature": "layers_clear",
            "codepoint": "E53C"
        }, {
            "iconId": "local_activity",
            "name": "local activity",
            "groupId": "maps",
            "ligature": "local_activity",
            "codepoint": "E53F"
        }, {
            "iconId": "local_airport",
            "name": "local airport",
            "groupId": "maps",
            "ligature": "local_airport",
            "codepoint": "E53D"
        }, {
            "iconId": "local_atm",
            "name": "local atm",
            "groupId": "maps",
            "ligature": "local_atm",
            "codepoint": "E53E"
        }, {
            "iconId": "local_bar",
            "name": "local bar",
            "groupId": "maps",
            "ligature": "local_bar",
            "codepoint": "E540"
        }, {
            "iconId": "local_cafe",
            "name": "local cafe",
            "groupId": "maps",
            "ligature": "local_cafe",
            "codepoint": "E541"
        }, {
            "iconId": "local_car_wash",
            "name": "local car wash",
            "groupId": "maps",
            "ligature": "local_car_wash",
            "codepoint": "E542"
        }, {
            "iconId": "local_convenience_store",
            "name": "local convenience store",
            "groupId": "maps",
            "ligature": "local_convenience_store",
            "codepoint": "E543"
        }, {
            "iconId": "local_dining",
            "name": "local dining",
            "groupId": "maps",
            "ligature": "local_dining",
            "codepoint": "E556"
        }, {
            "iconId": "local_drink",
            "name": "local drink",
            "groupId": "maps",
            "ligature": "local_drink",
            "codepoint": "E544"
        }, {
            "iconId": "local_florist",
            "name": "local florist",
            "groupId": "maps",
            "ligature": "local_florist",
            "codepoint": "E545"
        }, {
            "iconId": "local_gas_station",
            "name": "local gas station",
            "groupId": "maps",
            "ligature": "local_gas_station",
            "codepoint": "E546"
        }, {
            "iconId": "local_grocery_store",
            "name": "local grocery store",
            "groupId": "maps",
            "ligature": "local_grocery_store",
            "codepoint": "E547"
        }, {
            "iconId": "local_hospital",
            "name": "local hospital",
            "groupId": "maps",
            "ligature": "local_hospital",
            "codepoint": "E548"
        }, {
            "iconId": "local_hotel",
            "name": "local hotel",
            "groupId": "maps",
            "ligature": "local_hotel",
            "codepoint": "E549"
        }, {
            "iconId": "local_laundry_service",
            "name": "local laundry service",
            "groupId": "maps",
            "ligature": "local_laundry_service",
            "codepoint": "E54A"
        }, {
            "iconId": "local_library",
            "name": "local library",
            "groupId": "maps",
            "ligature": "local_library",
            "codepoint": "E54B"
        }, {
            "iconId": "local_mall",
            "name": "local mall",
            "groupId": "maps",
            "ligature": "local_mall",
            "codepoint": "E54C"
        }, {
            "iconId": "local_movies",
            "name": "local movies",
            "groupId": "maps",
            "ligature": "local_movies",
            "codepoint": "E54D"
        }, {
            "iconId": "local_offer",
            "name": "local offer",
            "groupId": "maps",
            "ligature": "local_offer",
            "codepoint": "E54E"
        }, {
            "iconId": "local_parking",
            "name": "local parking",
            "groupId": "maps",
            "ligature": "local_parking",
            "codepoint": "E54F"
        }, {
            "iconId": "local_pharmacy",
            "name": "local pharmacy",
            "groupId": "maps",
            "ligature": "local_pharmacy",
            "codepoint": "E550"
        }, {
            "iconId": "local_phone",
            "name": "local phone",
            "groupId": "maps",
            "ligature": "local_phone",
            "codepoint": "E551"
        }, {
            "iconId": "local_pizza",
            "name": "local pizza",
            "groupId": "maps",
            "ligature": "local_pizza",
            "codepoint": "E552"
        }, {
            "iconId": "local_play",
            "name": "local play",
            "groupId": "maps",
            "ligature": "local_play",
            "codepoint": "E553"
        }, {
            "iconId": "local_post_office",
            "name": "local post office",
            "groupId": "maps",
            "ligature": "local_post_office",
            "codepoint": "E554"
        }, {
            "iconId": "local_printshop",
            "name": "local printshop",
            "groupId": "maps",
            "ligature": "local_printshop",
            "codepoint": "E555"
        }, {
            "iconId": "local_see",
            "name": "local see",
            "groupId": "maps",
            "ligature": "local_see",
            "codepoint": "E557"
        }, {
            "iconId": "local_shipping",
            "name": "local shipping",
            "groupId": "maps",
            "ligature": "local_shipping",
            "codepoint": "E558"
        }, {
            "iconId": "local_taxi",
            "name": "local taxi",
            "groupId": "maps",
            "ligature": "local_taxi",
            "codepoint": "E559"
        }, {
            "iconId": "map",
            "name": "map",
            "groupId": "maps",
            "ligature": "map",
            "codepoint": "E55B"
        }, {
            "iconId": "my_location",
            "name": "my location",
            "groupId": "maps",
            "ligature": "my_location",
            "codepoint": "E55C"
        }, {
            "iconId": "navigation",
            "name": "navigation",
            "groupId": "maps",
            "ligature": "navigation",
            "codepoint": "E55D"
        }, {
            "iconId": "near_me",
            "name": "near me",
            "groupId": "maps",
            "ligature": "near_me",
            "codepoint": "E569"
        }, {
            "iconId": "person_pin",
            "name": "person pin",
            "groupId": "maps",
            "ligature": "person_pin",
            "codepoint": "E55A"
        }, {
            "iconId": "person_pin_circle",
            "name": "person pin circle",
            "groupId": "maps",
            "ligature": "person_pin_circle",
            "codepoint": "E56A"
        }, {
            "iconId": "pin_drop",
            "name": "pin drop",
            "groupId": "maps",
            "ligature": "pin_drop",
            "codepoint": "E55E"
        }, {
            "iconId": "place",
            "name": "place",
            "groupId": "maps",
            "ligature": "place",
            "codepoint": "E55F"
        }, {
            "iconId": "rate_review",
            "name": "rate review",
            "groupId": "maps",
            "ligature": "rate_review",
            "codepoint": "E560"
        }, {
            "iconId": "restaurant",
            "name": "restaurant",
            "groupId": "maps",
            "ligature": "restaurant",
            "codepoint": "E56C"
        }, {
            "iconId": "restaurant_menu",
            "name": "restaurant menu",
            "groupId": "maps",
            "ligature": "restaurant_menu",
            "codepoint": "E561"
        }, {
            "iconId": "satellite",
            "name": "satellite",
            "groupId": "maps",
            "ligature": "satellite",
            "codepoint": "E562"
        }, {
            "iconId": "store_mall_directory",
            "name": "store mall directory",
            "groupId": "maps",
            "ligature": "store_mall_directory",
            "codepoint": "E563"
        }, {
            "iconId": "streetview",
            "name": "streetview",
            "groupId": "maps",
            "ligature": "streetview",
            "codepoint": "E56E"
        }, {
            "iconId": "subway",
            "name": "subway",
            "groupId": "maps",
            "ligature": "subway",
            "codepoint": "E56F"
        }, {
            "iconId": "terrain",
            "name": "terrain",
            "groupId": "maps",
            "ligature": "terrain",
            "codepoint": "E564"
        }, {
            "iconId": "traffic",
            "name": "traffic",
            "groupId": "maps",
            "ligature": "traffic",
            "codepoint": "E565"
        }, {
            "iconId": "train",
            "name": "train",
            "groupId": "maps",
            "ligature": "train",
            "codepoint": "E570"
        }, {
            "iconId": "tram",
            "name": "tram",
            "groupId": "maps",
            "ligature": "tram",
            "codepoint": "E571"
        }, {
            "iconId": "transfer_within_a_station",
            "name": "transfer within a station",
            "groupId": "maps",
            "ligature": "transfer_within_a_station",
            "codepoint": "E572"
        }, {
            "iconId": "zoom_out_map",
            "name": "zoom out map",
            "groupId": "maps",
            "ligature": "zoom_out_map",
            "codepoint": "E56B"
        }, {
            "iconId": "apps",
            "name": "apps",
            "groupId": "navigation",
            "ligature": "apps",
            "codepoint": "E5C3"
        }, {
            "iconId": "arrow_back",
            "name": "arrow back",
            "groupId": "navigation",
            "ligature": "arrow_back",
            "codepoint": "E5C4"
        }, {
            "iconId": "arrow_downward",
            "name": "arrow downward",
            "groupId": "navigation",
            "ligature": "arrow_downward",
            "codepoint": "E5DB"
        }, {
            "iconId": "arrow_drop_down",
            "name": "arrow drop down",
            "groupId": "navigation",
            "ligature": "arrow_drop_down",
            "codepoint": "E5C5"
        }, {
            "iconId": "arrow_drop_down_circle",
            "name": "arrow drop down circle",
            "groupId": "navigation",
            "ligature": "arrow_drop_down_circle",
            "codepoint": "E5C6"
        }, {
            "iconId": "arrow_drop_up",
            "name": "arrow drop up",
            "groupId": "navigation",
            "ligature": "arrow_drop_up",
            "codepoint": "E5C7"
        }, {
            "iconId": "arrow_forward",
            "name": "arrow forward",
            "groupId": "navigation",
            "ligature": "arrow_forward",
            "codepoint": "E5C8"
        }, {
            "iconId": "arrow_upward",
            "name": "arrow upward",
            "groupId": "navigation",
            "ligature": "arrow_upward",
            "codepoint": "E5D8"
        }, {
            "iconId": "cancel",
            "name": "cancel",
            "groupId": "navigation",
            "ligature": "cancel",
            "codepoint": "E5C9"
        }, {
            "iconId": "check",
            "name": "check",
            "groupId": "navigation",
            "ligature": "check",
            "codepoint": "E5CA"
        }, {
            "iconId": "chevron_left",
            "name": "chevron left",
            "groupId": "navigation",
            "ligature": "chevron_left",
            "codepoint": "E5CB"
        }, {
            "iconId": "chevron_right",
            "name": "chevron right",
            "groupId": "navigation",
            "ligature": "chevron_right",
            "codepoint": "E5CC"
        }, {
            "iconId": "close",
            "name": "close",
            "groupId": "navigation",
            "ligature": "close",
            "codepoint": "E5CD"
        }, {
            "iconId": "expand_less",
            "name": "expand less",
            "groupId": "navigation",
            "ligature": "expand_less",
            "codepoint": "E5CE"
        }, {
            "iconId": "expand_more",
            "name": "expand more",
            "groupId": "navigation",
            "ligature": "expand_more",
            "codepoint": "E5CF"
        }, {
            "iconId": "first_page",
            "name": "first page",
            "groupId": "navigation",
            "ligature": "first_page",
            "codepoint": "E5DC"
        }, {
            "iconId": "fullscreen",
            "name": "fullscreen",
            "groupId": "navigation",
            "ligature": "fullscreen",
            "codepoint": "E5D0"
        }, {
            "iconId": "fullscreen_exit",
            "name": "fullscreen exit",
            "groupId": "navigation",
            "ligature": "fullscreen_exit",
            "codepoint": "E5D1"
        }, {
            "iconId": "last_page",
            "name": "last page",
            "groupId": "navigation",
            "ligature": "last_page",
            "codepoint": "E5DD"
        }, {
            "iconId": "menu",
            "name": "menu",
            "groupId": "navigation",
            "ligature": "menu",
            "codepoint": "E5D2"
        }, {
            "iconId": "more_horiz",
            "name": "more horiz",
            "groupId": "navigation",
            "ligature": "more_horiz",
            "codepoint": "E5D3"
        }, {
            "iconId": "more_vert",
            "name": "more vert",
            "groupId": "navigation",
            "ligature": "more_vert",
            "codepoint": "E5D4"
        }, {
            "iconId": "refresh",
            "name": "refresh",
            "groupId": "navigation",
            "ligature": "refresh",
            "codepoint": "E5D5"
        }, {
            "iconId": "subdirectory_arrow_left",
            "name": "subdirectory arrow left",
            "groupId": "navigation",
            "ligature": "subdirectory_arrow_left",
            "codepoint": "E5D9"
        }, {
            "iconId": "subdirectory_arrow_right",
            "name": "subdirectory arrow right",
            "groupId": "navigation",
            "ligature": "subdirectory_arrow_right",
            "codepoint": "E5DA"
        }, {
            "iconId": "adb",
            "name": "adb",
            "groupId": "notification",
            "ligature": "adb",
            "codepoint": "E60E"
        }, {
            "iconId": "airline_seat_flat",
            "name": "airline seat flat",
            "groupId": "notification",
            "ligature": "airline_seat_flat",
            "codepoint": "E630"
        }, {
            "iconId": "airline_seat_flat_angled",
            "name": "airline seat flat angled",
            "groupId": "notification",
            "ligature": "airline_seat_flat_angled",
            "codepoint": "E631"
        }, {
            "iconId": "airline_seat_individual_suite",
            "name": "airline seat individual suite",
            "groupId": "notification",
            "ligature": "airline_seat_individual_suite",
            "codepoint": "E632"
        }, {
            "iconId": "airline_seat_legroom_extra",
            "name": "airline seat legroom extra",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_extra",
            "codepoint": "E633"
        }, {
            "iconId": "airline_seat_legroom_normal",
            "name": "airline seat legroom normal",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_normal",
            "codepoint": "E634"
        }, {
            "iconId": "airline_seat_legroom_reduced",
            "name": "airline seat legroom reduced",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_reduced",
            "codepoint": "E635"
        }, {
            "iconId": "airline_seat_recline_extra",
            "name": "airline seat recline extra",
            "groupId": "notification",
            "ligature": "airline_seat_recline_extra",
            "codepoint": "E636"
        }, {
            "iconId": "airline_seat_recline_normal",
            "name": "airline seat recline normal",
            "groupId": "notification",
            "ligature": "airline_seat_recline_normal",
            "codepoint": "E637"
        }, {
            "iconId": "bluetooth_audio",
            "name": "bluetooth audio",
            "groupId": "notification",
            "ligature": "bluetooth_audio",
            "codepoint": "E60F"
        }, {
            "iconId": "confirmation_number",
            "name": "confirmation number",
            "groupId": "notification",
            "ligature": "confirmation_number",
            "codepoint": "E638"
        }, {
            "iconId": "disc_full",
            "name": "disc full",
            "groupId": "notification",
            "ligature": "disc_full",
            "codepoint": "E610"
        }, {
            "iconId": "do_not_disturb",
            "name": "do not disturb",
            "groupId": "notification",
            "ligature": "do_not_disturb",
            "codepoint": "E612"
        }, {
            "iconId": "do_not_disturb_alt",
            "name": "do not disturb alt",
            "groupId": "notification",
            "ligature": "do_not_disturb_alt",
            "codepoint": "E611"
        }, {
            "iconId": "do_not_disturb_off",
            "name": "do not disturb off",
            "groupId": "notification",
            "ligature": "do_not_disturb_off",
            "codepoint": "E643"
        }, {
            "iconId": "do_not_disturb_on",
            "name": "do not disturb on",
            "groupId": "notification",
            "ligature": "do_not_disturb_on",
            "codepoint": "E644"
        }, {
            "iconId": "drive_eta",
            "name": "drive eta",
            "groupId": "notification",
            "ligature": "drive_eta",
            "codepoint": "E613"
        }, {
            "iconId": "enhanced_encryption",
            "name": "enhanced encryption",
            "groupId": "notification",
            "ligature": "enhanced_encryption",
            "codepoint": "E63F"
        }, {
            "iconId": "event_available",
            "name": "event available",
            "groupId": "notification",
            "ligature": "event_available",
            "codepoint": "E614"
        }, {
            "iconId": "event_busy",
            "name": "event busy",
            "groupId": "notification",
            "ligature": "event_busy",
            "codepoint": "E615"
        }, {
            "iconId": "event_note",
            "name": "event note",
            "groupId": "notification",
            "ligature": "event_note",
            "codepoint": "E616"
        }, {
            "iconId": "folder_special",
            "name": "folder special",
            "groupId": "notification",
            "ligature": "folder_special",
            "codepoint": "E617"
        }, {
            "iconId": "live_tv",
            "name": "live tv",
            "groupId": "notification",
            "ligature": "live_tv",
            "codepoint": "E639"
        }, {
            "iconId": "mms",
            "name": "mms",
            "groupId": "notification",
            "ligature": "mms",
            "codepoint": "E618"
        }, {
            "iconId": "more",
            "name": "more",
            "groupId": "notification",
            "ligature": "more",
            "codepoint": "E619"
        }, {
            "iconId": "network_check",
            "name": "network check",
            "groupId": "notification",
            "ligature": "network_check",
            "codepoint": "E640"
        }, {
            "iconId": "network_locked",
            "name": "network locked",
            "groupId": "notification",
            "ligature": "network_locked",
            "codepoint": "E61A"
        }, {
            "iconId": "no_encryption",
            "name": "no encryption",
            "groupId": "notification",
            "ligature": "no_encryption",
            "codepoint": "E641"
        }, {
            "iconId": "ondemand_video",
            "name": "ondemand video",
            "groupId": "notification",
            "ligature": "ondemand_video",
            "codepoint": "E63A"
        }, {
            "iconId": "personal_video",
            "name": "personal video",
            "groupId": "notification",
            "ligature": "personal_video",
            "codepoint": "E63B"
        }, {
            "iconId": "phone_bluetooth_speaker",
            "name": "phone bluetooth speaker",
            "groupId": "notification",
            "ligature": "phone_bluetooth_speaker",
            "codepoint": "E61B"
        }, {
            "iconId": "phone_forwarded",
            "name": "phone forwarded",
            "groupId": "notification",
            "ligature": "phone_forwarded",
            "codepoint": "E61C"
        }, {
            "iconId": "phone_in_talk",
            "name": "phone in talk",
            "groupId": "notification",
            "ligature": "phone_in_talk",
            "codepoint": "E61D"
        }, {
            "iconId": "phone_locked",
            "name": "phone locked",
            "groupId": "notification",
            "ligature": "phone_locked",
            "codepoint": "E61E"
        }, {
            "iconId": "phone_missed",
            "name": "phone missed",
            "groupId": "notification",
            "ligature": "phone_missed",
            "codepoint": "E61F"
        }, {
            "iconId": "phone_paused",
            "name": "phone paused",
            "groupId": "notification",
            "ligature": "phone_paused",
            "codepoint": "E620"
        }, {
            "iconId": "power",
            "name": "power",
            "groupId": "notification",
            "ligature": "power",
            "codepoint": "E63C"
        }, {
            "iconId": "priority_high",
            "name": "priority high",
            "groupId": "notification",
            "ligature": "priority_high",
            "codepoint": "E645"
        }, {
            "iconId": "sd_card",
            "name": "sd card",
            "groupId": "notification",
            "ligature": "sd_card",
            "codepoint": "E623"
        }, {
            "iconId": "sim_card_alert",
            "name": "sim card alert",
            "groupId": "notification",
            "ligature": "sim_card_alert",
            "codepoint": "E624"
        }, {
            "iconId": "sms",
            "name": "sms",
            "groupId": "notification",
            "ligature": "sms",
            "codepoint": "E625"
        }, {
            "iconId": "sms_failed",
            "name": "sms failed",
            "groupId": "notification",
            "ligature": "sms_failed",
            "codepoint": "E626"
        }, {
            "iconId": "sync",
            "name": "sync",
            "groupId": "notification",
            "ligature": "sync",
            "codepoint": "E627"
        }, {
            "iconId": "sync_disabled",
            "name": "sync disabled",
            "groupId": "notification",
            "ligature": "sync_disabled",
            "codepoint": "E628"
        }, {
            "iconId": "sync_problem",
            "name": "sync problem",
            "groupId": "notification",
            "ligature": "sync_problem",
            "codepoint": "E629"
        }, {
            "iconId": "system_update",
            "name": "system update",
            "groupId": "notification",
            "ligature": "system_update",
            "codepoint": "E62A"
        }, {
            "iconId": "tap_and_play",
            "name": "tap and play",
            "groupId": "notification",
            "ligature": "tap_and_play",
            "codepoint": "E62B"
        }, {
            "iconId": "time_to_leave",
            "name": "time to leave",
            "groupId": "notification",
            "ligature": "time_to_leave",
            "codepoint": "E62C"
        }, {
            "iconId": "vibration",
            "name": "vibration",
            "groupId": "notification",
            "ligature": "vibration",
            "codepoint": "E62D"
        }, {
            "iconId": "voice_chat",
            "name": "voice chat",
            "groupId": "notification",
            "ligature": "voice_chat",
            "codepoint": "E62E"
        }, {
            "iconId": "vpn_lock",
            "name": "vpn lock",
            "groupId": "notification",
            "ligature": "vpn_lock",
            "codepoint": "E62F"
        }, {
            "iconId": "wc",
            "name": "wc",
            "groupId": "notification",
            "ligature": "wc",
            "codepoint": "E63D"
        }, {
            "iconId": "wifi",
            "name": "wifi",
            "groupId": "notification",
            "ligature": "wifi",
            "codepoint": "E63E"
        }, {
            "iconId": "ac_unit",
            "name": "ac unit",
            "groupId": "places",
            "ligature": "ac_unit",
            "codepoint": "EB3B"
        }, {
            "iconId": "airport_shuttle",
            "name": "airport shuttle",
            "groupId": "places",
            "ligature": "airport_shuttle",
            "codepoint": "EB3C"
        }, {
            "iconId": "all_inclusive",
            "name": "all inclusive",
            "groupId": "places",
            "ligature": "all_inclusive",
            "codepoint": "EB3D"
        }, {
            "iconId": "beach_access",
            "name": "beach access",
            "groupId": "places",
            "ligature": "beach_access",
            "codepoint": "EB3E"
        }, {
            "iconId": "business_center",
            "name": "business center",
            "groupId": "places",
            "ligature": "business_center",
            "codepoint": "EB3F"
        }, {
            "iconId": "casino",
            "name": "casino",
            "groupId": "places",
            "ligature": "casino",
            "codepoint": "EB40"
        }, {
            "iconId": "child_care",
            "name": "child care",
            "groupId": "places",
            "ligature": "child_care",
            "codepoint": "EB41"
        }, {
            "iconId": "child_friendly",
            "name": "child friendly",
            "groupId": "places",
            "ligature": "child_friendly",
            "codepoint": "EB42"
        }, {
            "iconId": "fitness_center",
            "name": "fitness center",
            "groupId": "places",
            "ligature": "fitness_center",
            "codepoint": "EB43"
        }, {
            "iconId": "free_breakfast",
            "name": "free breakfast",
            "groupId": "places",
            "ligature": "free_breakfast",
            "codepoint": "EB44"
        }, {
            "iconId": "golf_course",
            "name": "golf course",
            "groupId": "places",
            "ligature": "golf_course",
            "codepoint": "EB45"
        }, {
            "iconId": "hot_tub",
            "name": "hot tub",
            "groupId": "places",
            "ligature": "hot_tub",
            "codepoint": "EB46"
        }, {
            "iconId": "kitchen",
            "name": "kitchen",
            "groupId": "places",
            "ligature": "kitchen",
            "codepoint": "EB47"
        }, {
            "iconId": "pool",
            "name": "pool",
            "groupId": "places",
            "ligature": "pool",
            "codepoint": "EB48"
        }, {
            "iconId": "room_service",
            "name": "room service",
            "groupId": "places",
            "ligature": "room_service",
            "codepoint": "EB49"
        }, {
            "iconId": "rv_hookup",
            "name": "rv hookup",
            "groupId": "places",
            "ligature": "rv_hookup",
            "codepoint": "E642"
        }, {
            "iconId": "smoke_free",
            "name": "smoke free",
            "groupId": "places",
            "ligature": "smoke_free",
            "codepoint": "EB4A"
        }, {
            "iconId": "smoking_rooms",
            "name": "smoking rooms",
            "groupId": "places",
            "ligature": "smoking_rooms",
            "codepoint": "EB4B"
        }, {
            "iconId": "spa",
            "name": "spa",
            "groupId": "places",
            "ligature": "spa",
            "codepoint": "EB4C"
        }, {
            "iconId": "cake",
            "name": "cake",
            "groupId": "social",
            "ligature": "cake",
            "codepoint": "E7E9"
        }, {
            "iconId": "domain",
            "name": "domain",
            "groupId": "social",
            "ligature": "domain",
            "codepoint": "E7EE"
        }, {
            "iconId": "group",
            "name": "group",
            "groupId": "social",
            "ligature": "group",
            "codepoint": "E7EF"
        }, {
            "iconId": "group_add",
            "name": "group add",
            "groupId": "social",
            "ligature": "group_add",
            "codepoint": "E7F0"
        }, {
            "iconId": "location_city",
            "name": "location city",
            "groupId": "social",
            "ligature": "location_city",
            "codepoint": "E7F1"
        }, {
            "iconId": "mood",
            "name": "mood",
            "groupId": "social",
            "ligature": "mood",
            "codepoint": "E7F2"
        }, {
            "iconId": "mood_bad",
            "name": "mood bad",
            "groupId": "social",
            "ligature": "mood_bad",
            "codepoint": "E7F3"
        }, {
            "iconId": "notifications",
            "name": "notifications",
            "groupId": "social",
            "ligature": "notifications",
            "codepoint": "E7F4"
        }, {
            "iconId": "notifications_active",
            "name": "notifications active",
            "groupId": "social",
            "ligature": "notifications_active",
            "codepoint": "E7F7"
        }, {
            "iconId": "notifications_none",
            "name": "notifications none",
            "groupId": "social",
            "ligature": "notifications_none",
            "codepoint": "E7F5"
        }, {
            "iconId": "notifications_off",
            "name": "notifications off",
            "groupId": "social",
            "ligature": "notifications_off",
            "codepoint": "E7F6"
        }, {
            "iconId": "notifications_paused",
            "name": "notifications paused",
            "groupId": "social",
            "ligature": "notifications_paused",
            "codepoint": "E7F8"
        }, {
            "iconId": "pages",
            "name": "pages",
            "groupId": "social",
            "ligature": "pages",
            "codepoint": "E7F9"
        }, {
            "iconId": "party_mode",
            "name": "party mode",
            "groupId": "social",
            "ligature": "party_mode",
            "codepoint": "E7FA"
        }, {
            "iconId": "people",
            "name": "people",
            "groupId": "social",
            "ligature": "people",
            "codepoint": "E7FB"
        }, {
            "iconId": "people_outline",
            "name": "people outline",
            "groupId": "social",
            "ligature": "people_outline",
            "codepoint": "E7FC"
        }, {
            "iconId": "person",
            "name": "person",
            "groupId": "social",
            "ligature": "person",
            "codepoint": "E7FD"
        }, {
            "iconId": "person_add",
            "name": "person add",
            "groupId": "social",
            "ligature": "person_add",
            "codepoint": "E7FE"
        }, {
            "iconId": "person_outline",
            "name": "person outline",
            "groupId": "social",
            "ligature": "person_outline",
            "codepoint": "E7FF"
        }, {
            "iconId": "plus_one",
            "name": "plus one",
            "groupId": "social",
            "ligature": "plus_one",
            "codepoint": "E800"
        }, {
            "iconId": "poll",
            "name": "poll",
            "groupId": "social",
            "ligature": "poll",
            "codepoint": "E801"
        }, {
            "iconId": "public",
            "name": "public",
            "groupId": "social",
            "ligature": "public",
            "codepoint": "E80B"
        }, {
            "iconId": "school",
            "name": "school",
            "groupId": "social",
            "ligature": "school",
            "codepoint": "E80C"
        }, {
            "iconId": "sentiment_dissatisfied",
            "name": "sentiment dissatisfied",
            "groupId": "social",
            "ligature": "sentiment_dissatisfied",
            "codepoint": "E811"
        }, {
            "iconId": "sentiment_neutral",
            "name": "sentiment neutral",
            "groupId": "social",
            "ligature": "sentiment_neutral",
            "codepoint": "E812"
        }, {
            "iconId": "sentiment_satisfied",
            "name": "sentiment satisfied",
            "groupId": "social",
            "ligature": "sentiment_satisfied",
            "codepoint": "E813"
        }, {
            "iconId": "sentiment_very_dissatisfied",
            "name": "sentiment very dissatisfied",
            "groupId": "social",
            "ligature": "sentiment_very_dissatisfied",
            "codepoint": "E814"
        }, {
            "iconId": "sentiment_very_satisfied",
            "name": "sentiment very satisfied",
            "groupId": "social",
            "ligature": "sentiment_very_satisfied",
            "codepoint": "E815"
        }, {
            "iconId": "share",
            "name": "share",
            "groupId": "social",
            "ligature": "share",
            "codepoint": "E80D"
        }, {
            "iconId": "whatshot",
            "name": "whatshot",
            "groupId": "social",
            "ligature": "whatshot",
            "codepoint": "E80E"
        }, {
            "iconId": "check_box",
            "name": "check box",
            "groupId": "toggle",
            "ligature": "check_box",
            "codepoint": "E834"
        }, {
            "iconId": "check_box_outline_blank",
            "name": "check box outline blank",
            "groupId": "toggle",
            "ligature": "check_box_outline_blank",
            "codepoint": "E835"
        }, {
            "iconId": "indeterminate_check_box",
            "name": "indeterminate check box",
            "groupId": "toggle",
            "ligature": "indeterminate_check_box",
            "codepoint": "E909"
        }, {
            "iconId": "radio_button_checked",
            "name": "radio button checked",
            "groupId": "toggle",
            "ligature": "radio_button_checked",
            "codepoint": "E837"
        }, {
            "iconId": "radio_button_unchecked",
            "name": "radio button unchecked",
            "groupId": "toggle",
            "ligature": "radio_button_unchecked",
            "codepoint": "E836"
        }, {
            "iconId": "star",
            "name": "star",
            "groupId": "toggle",
            "ligature": "star",
            "codepoint": "E838"
        }, {
            "iconId": "star_border",
            "name": "star border",
            "groupId": "toggle",
            "ligature": "star_border",
            "codepoint": "E83A"
        }, {
            "iconId": "star_half",
            "name": "star half",
            "groupId": "toggle",
            "ligature": "star_half",
            "codepoint": "E839"
        }],

        modelFromId(iconId) {
            const icon = _.findWhere(this.icons, {iconId});

            return new ButtonIconModel(icon);
        }

    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/MaterialIcons.js